import React, { useState, useEffect, useRef, useCallback } from 'react';
import { auth, db, functions } from './firebase';
import { 
  doc, onSnapshot, updateDoc, increment, collection, 
  addDoc, query, orderBy, setDoc, deleteDoc, 
  serverTimestamp, getDocs, runTransaction 
} from 'firebase/firestore';
import { formatarTempo, proximoTique } from './relogioPartida';
import { getFunctions, httpsCallable } from 'firebase/functions';
import { enviarNotificacao } from "./notificacoesService";
import { AGORA_APP_ID } from './agora-config';
import { useSessaoAgora } from './useSessaoAgora';
import { atualizarJogoDaJornada, somar } from './calendarioLiga';
import EstadoLigacaoEstadio from './EstadoLigacaoEstadio';
import { reproduzirVideoNoContentor } from './agoraSession';
import { useAlturaLinhaVideo } from './useAlturaLinhaVideo';
import { construirMapaJogadores, uidAgoraDoUtilizador, contentorLocalDoUtilizador, contentorDeRemoto, limparContentorDeRemoto } from './mapaJogadores';
import PopupAtualizacaoEstadio from './PopupAtualizacaoEstadio';
import { shouldShowStadiumUpdate, markStadiumUpdateShown } from './stadiumUpdate';
import { adicionarXP } from './tabelaNiveis';
import { calcularNivel, obterImagemAdepto, obterImagemJogador } from './tabelaNiveis';

// IMPORTAÇÃO DOS PRESENTES REAIS
// 1. IMPORTAÇÕES (Tudo em minúsculas como na tua pasta)
// ==========================================
// LISTA MESTRE DE PRESENTES PREMIUM (50 FUTEBOL)
// ==========================================

// Bloco Novos Presentes (Futebol)
// Bloco 1 (150 Moedas)
import imgGift90Minutos from './assets/presentes/miniaturas/gift_90_minutos.webp';
import vidGift90Minutos from './assets/presentes/leves/gift_90_minutos.webm';

import imgGiftAnelCampeao from './assets/presentes/miniaturas/gift_anel_de_campeao.webp';
import vidGiftAnelCampeao from './assets/presentes/leves/gift_anel_de_campeao.webm';

import imgGiftApito from './assets/presentes/miniaturas/gift_apito.webp';
import vidGiftApito from './assets/presentes/leves/gift_apito.webm';

import imgGiftBaliza from './assets/presentes/miniaturas/gift_baliza.webp';
import vidGiftBaliza from './assets/presentes/leves/gift_baliza.webm';

import imgGiftBancadaVip from './assets/presentes/miniaturas/gift_bancada_vip.webp';
import vidGiftBancadaVip from './assets/presentes/leves/gift_bancada_vip.webm';

import imgGiftBancoSuplentes from './assets/presentes/miniaturas/gift_banco_de_suplentes.webp';
import vidGiftBancoSuplentes from './assets/presentes/leves/gift_banco_de_suplentes.webm';

import imgGiftBandeiraClaque from './assets/presentes/miniaturas/gift_bandeira_da_claque.webp';
import vidGiftBandeiraClaque from './assets/presentes/leves/gift_bandeira_da_claque.webm';

import imgGiftBandeirolaCanto from './assets/presentes/miniaturas/gift_bandeirola_de_canto.webp';
import vidGiftBandeirolaCanto from './assets/presentes/leves/gift_bandeirola_de_canto.webm';

import imgGiftBolaOuro from './assets/presentes/miniaturas/gift_bola_de_ouro.webp';
import vidGiftBolaOuro from './assets/presentes/leves/gift_bola_de_ouro.webm';

import imgGiftBolaChamas from './assets/presentes/miniaturas/gift_bola_em_chamas.webp';
import vidGiftBolaChamas from './assets/presentes/leves/gift_bola_em_chamas.webm';

// Bloco Novos Presentes - Grupo 2 (Futebol)
import imgGiftBotaDiamante from './assets/presentes/miniaturas/gift_bota_de_diamante.webp';
import vidGiftBotaDiamante from './assets/presentes/leves/gift_bota_de_diamante.webm';

import imgGiftBrasao from './assets/presentes/miniaturas/gift_brasao.webp';
import vidGiftBrasao from './assets/presentes/leves/gift_brasao.webm';

import imgGiftCachecol from './assets/presentes/miniaturas/gift_cachecol.webp';
import vidGiftCachecol from './assets/presentes/leves/gift_cachecol.webm';

import imgGiftCaneleiras from './assets/presentes/miniaturas/gift_caneleiras.webp';
import vidGiftCaneleiras from './assets/presentes/leves/gift_caneleiras.webm';

import imgGiftCanhaoCamisolas from './assets/presentes/miniaturas/gift_canhao_de_camisolas.webp';
import vidGiftCanhaoCamisolas from './assets/presentes/leves/gift_canhao_de_camisolas.webm';

import imgGiftCanhaoConfetes from './assets/presentes/miniaturas/gift_canhao_de_confetes.webp';
import vidGiftCanhaoConfetes from './assets/presentes/leves/gift_canhao_de_confetes.webm';

import imgGiftCapitao from './assets/presentes/miniaturas/gift_capitao.webp';
import vidGiftCapitao from './assets/presentes/leves/gift_capitao.webm';

import imgGiftCartaoAmarelo from './assets/presentes/miniaturas/gift_cartao_amarelo.webp';
import vidGiftCartaoAmarelo from './assets/presentes/leves/gift_cartao_amarelo.webm';

import imgGiftCartaoVermelho from './assets/presentes/miniaturas/gift_cartao_vermelho.webp';
import vidGiftCartaoVermelho from './assets/presentes/leves/gift_cartao_vermelho.webm';

import imgGiftChapeuGuardaRedes from './assets/presentes/miniaturas/gift_chapeu_de_guarda_redes.webp';
import vidGiftChapeuGuardaRedes from './assets/presentes/leves/gift_chapeu_de_guarda_redes.webm';

// Bloco Novos Presentes - Grupo 3 (Futebol)
import imgGiftChuteira from './assets/presentes/miniaturas/gift_chuteira.webp';
import vidGiftChuteira from './assets/presentes/leves/gift_chuteira.webm';

import imgGiftChuteirasChamas from './assets/presentes/miniaturas/gift_chuteiras_em_chamas.webp';
import vidGiftChuteirasChamas from './assets/presentes/leves/gift_chuteiras_em_chamas.webm';

import imgGiftCronometro from './assets/presentes/miniaturas/gift_cronometro.webp';
import vidGiftCronometro from './assets/presentes/leves/gift_cronometro.webm';

import imgGiftFiscalLinha from './assets/presentes/miniaturas/gift_fiscal_de_linha.webp';
import vidGiftFiscalLinha from './assets/presentes/leves/gift_fiscal_de_linha.webm';

import imgGiftFitasClaque from './assets/presentes/miniaturas/gift_fitas_da_claque.webp';
import vidGiftFitasClaque from './assets/presentes/leves/gift_fitas_da_claque.webm';

import imgGiftFumoClaque from './assets/presentes/miniaturas/gift_fumo_da_claque.webp';
import vidGiftFumoClaque from './assets/presentes/leves/gift_fumo_da_claque.webm';

import imgGiftGorroAdepto from './assets/presentes/miniaturas/gift_gorro_do_adepto.webp';
import vidGiftGorroAdepto from './assets/presentes/leves/gift_gorro_do_adepto.webm';

import imgGiftHallEntrada from './assets/presentes/miniaturas/gift_hall_de_entrada.webp';
import vidGiftHallEntrada from './assets/presentes/leves/gift_hall_de_entrada.webm';

import imgGiftHatTrick from './assets/presentes/miniaturas/gift_hat_trick.webp';
import vidGiftHatTrick from './assets/presentes/leves/gift_hat_trick.webm';

import imgGiftHolofotes from './assets/presentes/miniaturas/gift_holofotes.webp';
import vidGiftHolofotes from './assets/presentes/leves/gift_holofotes.webm';

// Bloco Novos Presentes - Grupo 4 (Futebol)
import imgGiftLuvaEspuma from './assets/presentes/miniaturas/gift_luva_de_espuma.webp';
import vidGiftLuvaEspuma from './assets/presentes/leves/gift_luva_de_espuma.webm';

import imgGiftLuvaPlatina from './assets/presentes/miniaturas/gift_luva_de_platina.webp';
import vidGiftLuvaPlatina from './assets/presentes/leves/gift_luva_de_platina.webm';

import imgGiftLuvasGuardaRedes from './assets/presentes/miniaturas/gift_luvas_de_guarda_redes.webp';
import vidGiftLuvasGuardaRedes from './assets/presentes/leves/gift_luvas_de_guarda_redes.webm';

import imgGiftMedalhaCampeao from './assets/presentes/miniaturas/gift_medalha_de_campeao.webp';
import vidGiftMedalhaCampeao from './assets/presentes/leves/gift_medalha_de_campeao.webm';

import imgGiftMedalhaViceCampeao from './assets/presentes/miniaturas/gift_medalha_de_vice_campeao.webp';
import vidGiftMedalhaViceCampeao from './assets/presentes/leves/gift_medalha_de_vice_campeao.webm';

import imgGiftMegafone from './assets/presentes/miniaturas/gift_megafone.webp';
import vidGiftMegafone from './assets/presentes/leves/gift_megafone.webm';

import imgGiftMeias from './assets/presentes/miniaturas/gift_meias.webp';
import vidGiftMeias from './assets/presentes/leves/gift_meias.webm';

import imgGiftMelhorTreinador from './assets/presentes/miniaturas/gift_melhor_treinador.webp';
import vidGiftMelhorTreinador from './assets/presentes/leves/gift_melhor_treinador.webm';

import imgGiftMoedaAoAr from './assets/presentes/miniaturas/gift_moeda_ao_ar.webp';
import vidGiftMoedaAoAr from './assets/presentes/leves/gift_moeda_ao_ar.webm';

import imgGiftPlacard from './assets/presentes/miniaturas/gift_placard.webp';
import vidGiftPlacard from './assets/presentes/leves/gift_placard.webm';

// Bloco Novos Presentes - Grupo 5 (Futebol - Final)
import imgGiftRelvado from './assets/presentes/miniaturas/gift_relvado.webp';
import vidGiftRelvado from './assets/presentes/leves/gift_relvado.webm';

import imgGiftSprayBarreira from './assets/presentes/miniaturas/gift_spray_de_barreira.webp';
import vidGiftSprayBarreira from './assets/presentes/leves/gift_spray_de_barreira.webm';

import imgGiftSubstituicao from './assets/presentes/miniaturas/gift_substituicao.webp';
import vidGiftSubstituicao from './assets/presentes/leves/gift_substituicao.webm';

import imgGiftTacaSuprema from './assets/presentes/miniaturas/gift_taca_suprema.webp';
import vidGiftTacaSuprema from './assets/presentes/leves/gift_taca_suprema.webm';

import imgGiftTamborClaque from './assets/presentes/miniaturas/gift_tambor_da_claque.webp';
import vidGiftTamborClaque from './assets/presentes/leves/gift_tambor_da_claque.webm';

import imgGiftTorresEstadio from './assets/presentes/miniaturas/gift_torres_do_estadio.webp';
import vidGiftTorresEstadio from './assets/presentes/leves/gift_torres_do_estadio.webm';

import imgGiftTrofeuCampeao from './assets/presentes/miniaturas/gift_trofeu_de_campeao.webp';
import vidGiftTrofeuCampeao from './assets/presentes/leves/gift_trofeu_de_campeao.webm';

import imgGiftTrofeuGuardaRedes from './assets/presentes/miniaturas/gift_trofeu_de_guarda_redes.webp';
import vidGiftTrofeuGuardaRedes from './assets/presentes/leves/gift_trofeu_de_guarda_redes.webm';

import imgGiftVitoria from './assets/presentes/miniaturas/gift_vitoria.webp';
import vidGiftVitoria from './assets/presentes/leves/gift_vitoria.webm';

import imgGiftVuvuzela from './assets/presentes/miniaturas/gift_vuvuzela.webp';
import vidGiftVuvuzela from './assets/presentes/leves/gift_vuvuzela.webm';
import PresenteTransparente from './PresenteTransparente';
import { videoSemFundo } from './presentesSemFundo';
import { useAquecerPresentes } from './useAquecerPresentes';
import { useFilaDePresentes } from './filaDePresentes';

const LISTA_PRESENTES = [
  // ==========================================
  // BLOCO 1: 150 MOEDAS
  // ==========================================
  { id: 1, nome: '90 Minutos', preco: 150, icone: imgGift90Minutos, video: vidGift90Minutos },
  { id: 2, nome: 'Anel de Campeão', preco: 150, icone: imgGiftAnelCampeao, video: vidGiftAnelCampeao },
  { id: 3, nome: 'Apito', preco: 150, icone: imgGiftApito, video: vidGiftApito },
  { id: 4, nome: 'Baliza', preco: 150, icone: imgGiftBaliza, video: vidGiftBaliza },
  { id: 5, nome: 'Bancada VIP', preco: 150, icone: imgGiftBancadaVip, video: vidGiftBancadaVip },

  // ==========================================
  // BLOCO 2: 300 MOEDAS
  // ==========================================
  { id: 6, nome: 'Banco de Suplentes', preco: 300, icone: imgGiftBancoSuplentes, video: vidGiftBancoSuplentes },
  { id: 7, nome: 'Bandeira da Claque', preco: 300, icone: imgGiftBandeiraClaque, video: vidGiftBandeiraClaque },
  { id: 8, nome: 'Bandeirola de Canto', preco: 300, icone: imgGiftBandeirolaCanto, video: vidGiftBandeirolaCanto },
  { id: 9, nome: 'Bola de Ouro', preco: 300, icone: imgGiftBolaOuro, video: vidGiftBolaOuro },
  { id: 10, nome: 'Bola em Chamas', preco: 300, icone: imgGiftBolaChamas, video: vidGiftBolaChamas },

  // ==========================================
  // BLOCO 3: 450 MOEDAS
  // ==========================================
  { id: 11, nome: 'Bota de Diamante', preco: 450, icone: imgGiftBotaDiamante, video: vidGiftBotaDiamante },
  { id: 12, nome: 'Brasão', preco: 450, icone: imgGiftBrasao, video: vidGiftBrasao },
  { id: 13, nome: 'Cachecol', preco: 450, icone: imgGiftCachecol, video: vidGiftCachecol },
  { id: 14, nome: 'Caneleiras', preco: 450, icone: imgGiftCaneleiras, video: vidGiftCaneleiras },
  { id: 15, nome: 'Canhão de Camisolas', preco: 450, icone: imgGiftCanhaoCamisolas, video: vidGiftCanhaoCamisolas },

  // ==========================================
  // BLOCO 4: 600 MOEDAS
  // ==========================================
  { id: 16, nome: 'Canhão de Confetes', preco: 600, icone: imgGiftCanhaoConfetes, video: vidGiftCanhaoConfetes },
  { id: 17, nome: 'Capitão', preco: 600, icone: imgGiftCapitao, video: vidGiftCapitao },
  { id: 18, nome: 'Cartão Amarelo', preco: 600, icone: imgGiftCartaoAmarelo, video: vidGiftCartaoAmarelo },
  { id: 19, nome: 'Cartão Vermelho', preco: 600, icone: imgGiftCartaoVermelho, video: vidGiftCartaoVermelho },
  { id: 20, nome: 'Chapéu de Guarda-Redes', preco: 600, icone: imgGiftChapeuGuardaRedes, video: vidGiftChapeuGuardaRedes },

  // ==========================================
  // BLOCO 5: 750 MOEDAS
  // ==========================================
  { id: 21, nome: 'Chuteira', preco: 750, icone: imgGiftChuteira, video: vidGiftChuteira },
  { id: 22, nome: 'Chuteiras em Chamas', preco: 750, icone: imgGiftChuteirasChamas, video: vidGiftChuteirasChamas },
  { id: 23, nome: 'Cronómetro', preco: 750, icone: imgGiftCronometro, video: vidGiftCronometro },
  { id: 24, nome: 'Fiscal de Linha', preco: 750, icone: imgGiftFiscalLinha, video: vidGiftFiscalLinha },
  { id: 25, nome: 'Fitas da Claque', preco: 750, icone: imgGiftFitasClaque, video: vidGiftFitasClaque },

  // ==========================================
  // BLOCO 6: 900 MOEDAS
  // ==========================================
  { id: 26, nome: 'Fumo da Claque', preco: 900, icone: imgGiftFumoClaque, video: vidGiftFumoClaque },
  { id: 27, nome: 'Gorro do Adepto', preco: 900, icone: imgGiftGorroAdepto, video: vidGiftGorroAdepto },
  { id: 28, nome: 'Hall de Entrada', preco: 900, icone: imgGiftHallEntrada, video: vidGiftHallEntrada },
  { id: 29, nome: 'Hat-Trick', preco: 900, icone: imgGiftHatTrick, video: vidGiftHatTrick },
  { id: 30, nome: 'Holofotes', preco: 900, icone: imgGiftHolofotes, video: vidGiftHolofotes },

  // ==========================================
  // BLOCO 7: 1050 MOEDAS
  // ==========================================
  { id: 31, nome: 'Luva de Espuma', preco: 1050, icone: imgGiftLuvaEspuma, video: vidGiftLuvaEspuma },
  { id: 32, nome: 'Luva de Platina', preco: 1050, icone: imgGiftLuvaPlatina, video: vidGiftLuvaPlatina },
  { id: 33, nome: 'Luvas de Guarda-Redes', preco: 1050, icone: imgGiftLuvasGuardaRedes, video: vidGiftLuvasGuardaRedes },
  { id: 34, nome: 'Medalha de Campeão', preco: 1050, icone: imgGiftMedalhaCampeao, video: vidGiftMedalhaCampeao },
  { id: 35, nome: 'Medalha de Vice-Campeão', preco: 1050, icone: imgGiftMedalhaViceCampeao, video: vidGiftMedalhaViceCampeao },

  // ==========================================
  // BLOCO 8: 1200 MOEDAS
  // ==========================================
  { id: 36, nome: 'Megafone', preco: 1200, icone: imgGiftMegafone, video: vidGiftMegafone },
  { id: 37, nome: 'Meias', preco: 1200, icone: imgGiftMeias, video: vidGiftMeias },
  { id: 38, nome: 'Melhor Treinador', preco: 1200, icone: imgGiftMelhorTreinador, video: vidGiftMelhorTreinador },
  { id: 39, nome: 'Moeda ao Ar', preco: 1200, icone: imgGiftMoedaAoAr, video: vidGiftMoedaAoAr },
  { id: 40, nome: 'Placard', preco: 1200, icone: imgGiftPlacard, video: vidGiftPlacard },

  // ==========================================
  // BLOCO 9: 1350 MOEDAS
  // ==========================================
  { id: 41, nome: 'Relvado', preco: 1350, icone: imgGiftRelvado, video: vidGiftRelvado },
  { id: 42, nome: 'Spray de Barreira', preco: 1350, icone: imgGiftSprayBarreira, video: vidGiftSprayBarreira },
  { id: 43, nome: 'Substituição', preco: 1350, icone: imgGiftSubstituicao, video: vidGiftSubstituicao },
  { id: 44, nome: 'Taça Suprema', preco: 1350, icone: imgGiftTacaSuprema, video: vidGiftTacaSuprema },
  { id: 45, nome: 'Tambor da Claque', preco: 1350, icone: imgGiftTamborClaque, video: vidGiftTamborClaque },

  // ==========================================
  // BLOCO 10: 1500 MOEDAS
  // ==========================================
  { id: 46, nome: 'Torres do Estádio', preco: 1500, icone: imgGiftTorresEstadio, video: vidGiftTorresEstadio },
  { id: 47, nome: 'Troféu de Campeão', preco: 1500, icone: imgGiftTrofeuCampeao, video: vidGiftTrofeuCampeao },
  { id: 48, nome: 'Troféu de Guarda-Redes', preco: 1500, icone: imgGiftTrofeuGuardaRedes, video: vidGiftTrofeuGuardaRedes },
  { id: 49, nome: 'Vitória', preco: 1500, icone: imgGiftVitoria, video: vidGiftVitoria },
  { id: 50, nome: 'Vuvuzela', preco: 1500, icone: imgGiftVuvuzela, video: vidGiftVuvuzela }
];

      function JogosLigaPK({ idLiga, chaveJornada, idJogoNaJornada, idBatalha, espectador = false, aoSair }) {
    // Põe os vídeos dos presentes a descarregar já, para o primeiro presente não chegar atrasado.
    useAquecerPresentes();
  const [batalha, setBatalha] = useState(null);
  const [mensagemJuiz, setMensagemJuiz] = useState("");
  const [poteBolasGeral, setPoteBolasGeral] = useState(0);
  // A linha de vídeo ocupa todo o espaço que sobra (ver useAlturaLinhaVideo.js).
  const { linhaRef: linhaVideoRef, altura: alturaLinhaVideo } = useAlturaLinhaVideo();
  const [mensagensChat, setMensagensChat] = useState([]);
  const [textoMensagem, setTextoMensagem] = useState("");

  // FILA DE PRESENTES: um de cada vez, os outros esperam; ao acabar entra o
  // seguinte. A bomba toca quando o presente ENTRA no ecrã. (src/filaDePresentes.js)
  const filaPresentes = useFilaDePresentes({
    aoComecar: () => {
      try {
        const somBomba = new Audio("/sounds/bomba-explosao.mp3");
        somBomba.volume = 1.0;
        somBomba.play().catch(e => console.log("Autoplay retido pelo browser:", e));
      } catch (errSom) {
        console.error("Erro ao reproduzir áudio no presente:", errSom);
      }
    },
  });
  const videoAtivo = filaPresentes.atual?.url || null;
  const chaveVideoAtivo = filaPresentes.atual?.chave || '';
  const [mostrarPresentesPK, setMostrarPresentesPK] = useState(false);
  const [streamerSelecionadoPresente, setStreamerSelecionadoPresente] = useState('A');

    // 🚀 DECLARAÇÃO DE SEGURANÇA: Controla o estado bicolor do microfone individual da Liga (Estilo Champions)
  const [microLigado, setMicroLigado] = useState(true);
  
  const [totalGente, setTotalGente] = useState(0);

    const idA = batalha?.idA || null;
  const idB = batalha?.idB || null;

  const [euPertencoAClaqueA, setEuPertencoAClaqueA] = useState(false);
  const [euPertencoAClaqueB, setEuPertencoAClaqueB] = useState(false);
  const [totalMembrosClaqueA, setTotalMembrosClaqueA] = useState(0);
  const [totalMembrosClaqueB, setTotalMembrosClaqueB] = useState(0);
  const [idsClaqueA, setIdsClaqueA] = useState([]);
  const [idsClaqueB, setIdsClaqueB] = useState([]);
  
    const ultimoTiqueRef = useRef({ tempo: null, em: Date.now() });
  const [relogioParado, setRelogioParado] = useState(false);

    const [mostrarResultadoFinal, setMostrarResultadoFinal] = useState(false);
  const [mostrarOpcoesFim, setMostrarOpcoesFim] = useState(false);

    const [mostrarEspectadoresPK, setMostrarEspectadoresPK] = useState(false);
  const [listaEspectadoresPK, setListaEspectadoresPK] = useState([]);
  const [mostrarListaEspectadores, setMostrarListaEspectadores] = useState(false);
  const [listaEspectadores, setListaEspectadores] = useState([]);

  const [totalTapTapsArena, setTotalTapTapsArena] = useState(0);
  const [tapsClaqueA, setTapsClaqueA] = useState(0);
  const [tapsClaqueB, setTapsClaqueB] = useState(0);

  const messagesEndRef = useRef(null);

    // SESSÃO AGORA partilhada (ver agoraSession.js).
  const ligacao = useSessaoAgora('JogosLigaPK');

  // 1. SENSOR MESTRE DA CLAQUE: Escuta os sócios e valida a tua pertença vitalícia na Liga PK
  useEffect(() => {
    if (!batalha?.idA || !auth.currentUser?.uid) return;
    const meuUidLogado = auth.currentUser.uid;
    let unsubMembrosA = null;
    let unsubMembrosB = null;

    const iniciarSensoresMembrosLiga = async () => {
      try {
        const { doc: fDoc, getDoc: fGetDoc, collection: fColl, onSnapshot: fOnSnapshot, query: fQuery, where: fWhere } = await import('firebase/firestore');
        
        // 🚀 ISOLAMENTO LIGA: Verifica se EU sou sócio na coleção exclusiva da Liga PK
        const docClaqueARef = fDoc(db, "utilizadores", batalha?.idA, "claque_liga_membros", meuUidLogado);
        const snapA = await fGetDoc(docClaqueARef);
        setEuPertencoAClaqueA(snapA.exists() && snapA.data()?.ativo === true);

        if (batalha?.idB) {
          const docClaqueBRef = fDoc(db, "utilizadores", batalha?.idB, "claque_liga_membros", meuUidLogado);
          const snapB = await fGetDoc(docClaqueBRef);
          setEuPertencoAClaqueB(snapB.exists() && snapB.data()?.ativo === true);
        }

        // Escuta em tempo real os sócios ativos da Liga PK para o Streamer A
        const claqueACollRef = fColl(db, "utilizadores", batalha?.idA, "claque_liga_membros");
        const qClaqueA = fQuery(claqueACollRef, fWhere("ativo", "==", true));
        unsubMembrosA = fOnSnapshot(qClaqueA, (snapCollA) => {
          setTotalMembrosClaqueA(snapCollA.size);
          setIdsClaqueA(snapCollA.docs.map(d => d.id));
        });

        // Escuta em tempo real os sócios ativos da Liga PK para o Streamer B
        if (batalha?.idB) {
          const claqueBCollRef = fColl(db, "utilizadores", batalha?.idB, "claque_liga_membros");
          const qClaqueB = fQuery(claqueBCollRef, fWhere("ativo", "==", true));
          unsubMembrosB = fOnSnapshot(qClaqueB, (snapCollB) => {
            setTotalMembrosClaqueB(snapCollB.size);
            setIdsClaqueB(snapCollB.docs.map(d => d.id));
          });
        }
      } catch (errCheck) {
        console.error("Erro nos sensores de membros da claque da liga:", errCheck);
      }
    };

    iniciarSensoresMembrosLiga();
    return () => {
      if (unsubMembrosA) unsubMembrosA();
      if (unsubMembrosB) unsubMembrosB();
    };
  }, [batalha?.idA, batalha?.idB]);

  // 2. COMPRAR ABONO CLAQUE ESQUERDA (50% Streamer / 50% Admin - EXCLUSIVO LIGA PK)
  const comprarAbonoClaqueChampionsA = async () => {
    if (!batalha?.idA || !auth.currentUser?.uid) return;
    const meuUidLogado = auth.currentUser.uid;
    try {
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp, increment: fIncrement } = await import('firebase/firestore');
      const meuUserRef = fDoc(db, "utilizadores", meuUidLogado);
      const meuSnap = await fGetDoc(meuUserRef);
      const saldoBolasReal = meuSnap.data()?.saldoBolas || meuSnap.data()?.saldo || 0;

      if (saldoBolasReal < 300) {
        alert("Saldo insuficiente para entrar na Claque Oficial! ⚽");
        return;
      }

      const campoSaldo = meuSnap.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(meuUserRef, { [campoSaldo]: fIncrement(-300) });

              // ========================================================
        // XP AUTOMÁTICO - ABONO CLAQUE A (LIGA PK)
        // ========================================================
        if (meuUidLogado) {
          adicionarXP(meuUidLogado, 'adepto', 300);
        }
        if (batalla?.ida && batella.ida !== meuUidLogado) {
          adicionarXP(batalha.ida, 'jogador', 300);
        }
        // ========================================================

      const streamerARef = fDoc(db, "utilizadores", batalha.idA);
      const snapStrA = await fGetDoc(streamerARef);
      const campoSaldoStrA = snapStrA.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(streamerARef, { [campoSaldoStrA]: fIncrement(150) });

      const meuIdAdminTorneioClaque = "wkvSZZR5zdUvweoBuydAept6eOn1";
      await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminTorneioClaque), { comissaoAppBolas: fIncrement(150) }).catch(() => {});

      // 🚀 CORREÇÃO E ISOLAMENTO: Gravado na coleção unificada de claques da Liga PK
      const docClaqueARef = fDoc(db, "utilizadores", batalha.idA, "claque_liga_membros", meuUidLogado);
      await fSetDoc(docClaqueARef, { uid: meuUidLogado, nome: auth.currentUser?.displayName || "Adepto", foto: auth.currentUser?.photoURL || "", ativo: true, criadoEm: fTimestamp() });

      if (idBatalha) {
        // 🚀 CIRCUITO FECHADO LIGA: Escreve unicamente na coleção de diretos da Liga PK
        await fUpdateDoc(fDoc(db, "batalhasAtivas_liga", idBatalha), { claqueAtivosA: fIncrement(1) }).catch(() => {});
      }

      setEuPertencoAClaqueA(true);
      alert(`Bem-vindo à Claque Oficial de ${batalha?.nomeA || 'Anfitrião'}! 📣`);
    } catch (err) { console.error(err); }
  };

  // 3. COMPRAR ABONO CLAQUE DIREITA (50% Streamer / 50% Admin - EXCLUSIVO LIGA PK)
  const comprarAbonoClaqueChampionsB = async () => {
    if (!batalha?.idB || !auth.currentUser?.uid) return;
    const meuUidLogado = auth.currentUser.uid;
    try {
      const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc, setDoc: fSetDoc, serverTimestamp: fTimestamp, increment: fIncrement } = await import('firebase/firestore');
      const meuUserRef = fDoc(db, "utilizadores", meuUidLogado);
      const meuSnap = await fGetDoc(meuUserRef);
      const saldoBolasReal = meuSnap.data()?.saldoBolas || meuSnap.data()?.saldo || 0;

      if (saldoBolasReal < 300) {
        alert("Saldo insuficiente para entrar na Claque Oficial! ⚽");
        return;
      }

      const campoSaldo = meuSnap.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(meuUserRef, { [campoSaldo]: fIncrement(-300) });

              // ========================================================
        // XP AUTOMÁTICO - ABONO CLAQUE B (LIGA PK)
        // ========================================================
        if (meuUidLogado) {
          adicionarXP(meuUidLogado, 'adepto', 300);
        }
        if (batalha?.idB && batalha.idB !== meuUidLogado) {
          adicionarXP(batalha.idB, 'jogador', 300);
        }
        // ========================================================

      const streamerBRef = fDoc(db, "utilizadores", batalha.idB);
      const snapStrB = await fGetDoc(streamerBRef);
      const campoSaldoStrB = snapStrB.data()?.saldoBolas !== undefined ? "saldoBolas" : "saldo";
      await fUpdateDoc(streamerBRef, { [campoSaldoStrB]: fIncrement(150) });

      const meuIdAdminTorneioClaque = "wkvSZZR5zdUvweoBuydAept6eOn1";
      await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminTorneioClaque), { comissaoAppBolas: fIncrement(150) }).catch(() => {});

      // 🚀 CORREÇÃO E ISOLAMENTO: Gravado na coleção unificada de claques da Liga PK
      const docClaqueBRef = fDoc(db, "utilizadores", batalha.idB, "claque_liga_membros", meuUidLogado);
      await fSetDoc(docClaqueBRef, { uid: meuUidLogado, nome: auth.currentUser?.displayName || "Adepto", foto: auth.currentUser?.photoURL || "", ativo: true, criadoEm: fTimestamp() });

      if (idBatalha) {
        // 🚀 CIRCUITO FECHADO LIGA: Escreve unicamente na coleção de diretos da Liga PK
        await fUpdateDoc(fDoc(db, "batalhasAtivas_liga", idBatalha), { claqueAtivosB: fIncrement(1) }).catch(() => {});
      }

      setEuPertencoAClaqueB(true);
      alert(`Bem-vindo à Claque Oficial de ${batalha?.nomeB || 'Rival'}! 📣`);
    } catch (err) { console.error(err); }
  };

      // ⚡ MOTOR DE TAP-TAPS EM RAJADAS ACUMULADAS (ISOLADO PARA A LIGA PK CONTRA CONGELAMENTO)
  const processarTapTapArena = async (e) => {
    if (e) e.stopPropagation();
    const cliquesNovos = (window.acumuladorTapsArena || 0) + 1;
    window.acumuladorTapsArena = cliquesNovos;

    if (window.acumuladorTapsArena >= 10) {
      window.acumuladorTapsArena = 0;
      try {
        if (idBatalha) {
          // 🚀 CIRCUITO FECHADO LIGA: Computa as rajadas apenas no direto isolado da Liga PK
          await updateDoc(doc(db, "batalhasAtivas_liga", idBatalha), {
            totalTapTaps: increment(10)
          });
        }
      } catch (erroTap) {
        console.error("Erro ao computar rajada de Tap Tap na Liga PK:", erroTap);
      }
    }
  };

  // REPOR O ESTADO DA PARTIDA.
  // Corre antes de cada partida nova. Sem isto sobravam do jogo anterior o
  // resultado final, o chat, a animação do último presente e o placar local.
  const reporEstadoDaPartida = useCallback((limparBatalha = false) => {
    if (limparBatalha) setBatalha(null);
    filaPresentes.limpar();
    setMensagemJuiz("");
    setMensagensChat([]);
    setTextoMensagem("");
  }, []);

  // Partida nova (id diferente): limpa tudo, incluindo o documento antigo.
  useEffect(() => {
    reporEstadoDaPartida(true);
  }, [idBatalha, reporEstadoDaPartida]);
  const scrollToBottom = () => { messagesEndRef.current?.scrollIntoView({ behavior: "smooth" }); };

  // AVISO DIÁRIO DE NOVIDADES DO ESTÁDIO (DESATIVADO NA LIGA PARA NÃO BLOQUEAR O ENTRAR EM CAMPO)
  const [mostrarAvisoEstadio, setMostrarAvisoEstadio] = useState(false);

  useEffect(() => {
    setMostrarAvisoEstadio(false);
  }, []);

    // 1. MOTOR FINANCEIRO DA LIGA PK (65% STREAMER / 15% POTE / 15% APP / 5% CASHBACK VIP - CIRCUITO ISOLADO)
  const enviarPresenteLiga = async (presente, receptorID) => {
    const faseTexto = String(batalha?.fase || "").toUpperCase().trim();
    // 🛡️ REGRAS DE TEMPO RÍGIDAS PRESERVADAS: Só deixa doar rigorosamente na 1ª ou 2ª Parte
    if (faseTexto !== "1ª PARTE" && faseTexto !== "2ª PARTE") return;
    
    // 🚀 DUPLA ANTENA: Se o idLiga não vier por propriedade, resgata-o do próprio nó reativo do jogo
    const idLigaReal = idLiga || batalha?.idLiga;
    if (!idLigaReal || !receptorID) return;

    try {
      const { doc: fDoc, updateDoc: fUpdateDoc, increment: fIncrement, setDoc: fSetDoc } = await import('firebase/firestore');

      // 🚀 CORREÇÃO 1: Deduz síncronamente do campo oficial "saldoBolas" da PWA
      await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), {
        saldoBolas: fIncrement(-presente.preco)
      });

      // 🚀 CIRCUITO FECHADO LIGA: CÁLCULO ATÓMICO DIRETAMENTE NO OBJETO DE JORNADAS DO DOCUMENTO MESTRE
      const chaveJornada = `jornada_${batalha?.jornada || 1}`;
      const campoPontosTabela = receptorID === batalha.idA ? "pontosP1" : "pontosP2";
      const caminhoObjetoLiga = `jornadas.${chaveJornada}.${idJogoNaJornada}.${campoPontosTabela}`;

      await fUpdateDoc(fDoc(db, "ligas_ativas", idLiga), {
        [caminhoObjetoLiga]: fIncrement(presente.preco)
      }).catch(e => console.log("Aviso ao atualizar pontos no mapa da liga:", e));

      // 🚀 CIRCUITO FECHADO LIVE: Registra os pontos na batalha em direto e dispara a animação de vídeo
      const campoPontosLive = receptorID === batalha.idA ? "pontosA" : "pontosB";
      await fUpdateDoc(fDoc(db, "batalhasAtivas_liga", idBatalha), {
        [campoPontosLive]: fIncrement(presente.preco),
        ultimoVideo: presente.video
      });

          // CÁLCULO DAS PERCENTAGENS OFICIAIS 100% EM BOLAS (Liga PK: 65/15/15/5)
      const comissaoStreamerBolas = Math.round(presente.preco * 0.65); 
      const comissaoPoteBolas = Math.round(presente.preco * 0.15);      
      const comissaoAppBolas = Math.round(presente.preco * 0.15);      
      const comissaoCashbackBolas = Math.round(presente.preco * 0.05); 

      // A. O Streamer recebe os seus 65% em moedas no campo oficial "saldoBolas"
      await fUpdateDoc(fDoc(db, "utilizadores", receptorID), { saldoBolas: fIncrement(comissaoStreamerBolas) });

      // B. O Grande Pote do Campeonato acumula os seus 15% em moedas (Bolas) diretamente na Liga rotativa ativa!
      await fUpdateDoc(fDoc(db, "ligas_ativas", idLiga), {
        poteAcumuladoBolas: fIncrement(comissaoPoteBolas),
        cashbackAcumuladoBolas: fIncrement(comissaoCashbackBolas)
      });

      // 🚀 CORREÇÃO 2: Envia a comissão da App em Bolas direto para a tua conta de Administrador Mestre!
      const meuIdAdminMestre = "wkvSZZR5zdUvweoBuydAept6eOn1";
      await fUpdateDoc(fDoc(db, "utilizadores", meuIdAdminMestre), {
        comissaoAppBolas: fIncrement(comissaoAppBolas)
      }).catch(e => console.error("Erro na comissão mestre da Liga:", e));

            // ========================================================
      // ENVIAR XP AUTOMÁTICO - PRESENTES LIGA PK
      // ========================================================
      const meuUidLigaGeral = auth?.currentUser?.uid;
      if (meuUidLigaGeral) {
        adicionarXP(meuUidLigaGeral, 'adepto', presente.preco);
      }
      if (receptorID && receptorID !== meuUidLigaGeral) {
        adicionarXP(receptorID, 'jogador', presente.preco);
      }
      // ========================================================

      // D. Registra o log do investidor para o cálculo do Cashback VIP diretamente no nó da liga
      const investidorRef = fDoc(db, "ligas_ativas", idLiga, "investidores_jornada", auth.currentUser.uid);
      await fSetDoc(investidorRef, {
        uid: auth.currentUser.uid,
        nome: auth.currentUser?.displayName || "Adepto VIP",
        totalGastoMoedas: fIncrement(presente.preco),
        atualizadoEm: Date.now()
      }, { merge: true });

            // 🚨 ALERTA PREMIUM NO CHAT LIGA PK: Injeta o log na subcoleção unificada (chatsArena) para ativar a esteira de Chroma Key!
      try {
        const { collection: fCollection, addDoc: fAddDoc, serverTimestamp: fServerTimestamp, doc: fDoc, getDoc: fGetDoc } = await import('firebase/firestore');
        const meuUserSnap = await fGetDoc(fDoc(db, "utilizadores", auth.currentUser.uid));
        
        const nomeAdeptoPresente = meuUserSnap.data()?.nomeCompleto || meuUserSnap.data()?.nome || auth.currentUser?.displayName || "Um adepto";
        const nomeDestinatarioPresente = receptorID === batalha?.idA ? (batalha?.nomeA || "Streamer A") : (batalha?.nomeB || "Streamer B");
        const fotoAdeptoPresente = meuUserSnap.data()?.fotoUrl || meuUserSnap.data()?.foto || auth.currentUser?.photoURL || "";

        await fAddDoc(fCollection(db, "batalhasAtivas_liga", idBatalha, "chatsArena"), {
          texto: ` enviou [${presente.nome || "Presente"}] para ${nomeDestinatarioPresente}! ⚽💥`,
          nome: "🏆 SISTEMA LIGA",
          nomeInfrator: `🎁 ${nomeAdeptoPresente}`, // Destaca o nome do adepto no chat limpo
          uid: "sistema_liga",
          fotoUrl: fotoAdeptoPresente, // Acaba de vez com a bola preta nas doações
          foto: fotoAdeptoPresente, 
          criadoEm: fServerTimestamp(),
          tipo: "sistema",
          videoGatilho: presente.video 
        });
        
        // 🚀 ATUALIZAÇÃO SINCRO DO POTE DA ARENA: Soma o prémio no contador do live em direto
        await fUpdateDoc(fDoc(db, "batalhasAtivas_liga", idBatalha), {
          ultimoVideo: presente.video,
          poteBolasJogo: fIncrement(Math.round(presente.preco * 0.15))
        }).catch(() => {});

      } catch (errChatLog) {
        console.error("Erro ao injetar alerta de presente no chat da Liga:", errChatLog);
      }

    } catch (err) { 
      console.error("Erro no envio do presente do campeonato:", err); 
    }
  };

      // 1.b ENTRADA NO CANAL DE VÍDEO DA JORNADA (ENGINE BLINDADA ANTI-ERRO 400)
  useEffect(() => {
    // TRANCA SUPREMA DE ENTRADA: Aborta imediatamente nos primeiros milissegundos se o ID da batalha ou dos DOIS jogadores não estiver povoado na memória!
    if (!idBatalha || idBatalha === "undefined" || auth.currentUser?.uid == null || !batalha?.idA || !batalha?.idB) {
      return;
    }

    const entrarNoCampo = async () => {
      let tokenReal = null;
      try {
        const chamarGerador = httpsCallable(functions, 'gerarTokenAgora');
                const idBatalhaSeguro = idBatalha || idJogoNaJornada || batalha?.id;
        const resultadoServidor = await chamarGerador({ 
          idBatalha: idBatalhaSeguro,
          idJogo: idBatalhaSeguro
        });
        tokenReal = resultadoServidor?.data?.token || null;
      } catch (eToken) {
        console.log("Token Agora indisponível, a entrar em modo App ID:", eToken?.message);
      }

      // Lugares determinísticos: idA -> uid 1 (esquerda), adversário -> uid 2 (direita). Nunca por ordem de chegada.
      const uidAgoraJogo = espectador ? null : uidAgoraDoUtilizador(batalha, auth.currentUser?.uid);

      await ligacao.entrar({
        appId: AGORA_APP_ID,
        canal: idBatalha,
        token: tokenReal,
        uid: uidAgoraJogo,
        publicar: !espectador,
        // A minha câmara vai para a MINHA janela (esquerda se for anfitrião, direita se for adversário).
        contentorLocal: espectador ? null : contentorLocalDoUtilizador(batalha, auth.currentUser?.uid),
        aoPublicarRemoto: (utilizador, tipoMedia) => {
          if (tipoMedia === "video") {
            // Uma só regra para jogadores e espetadores: a janela vem do uid.
            const contentor = contentorDeRemoto(utilizador.uid);
            if (contentor) reproduzirVideoNoContentor(utilizador.videoTrack, contentor);
          }
          if (tipoMedia === "audio") utilizador.audioTrack?.play();
        },
        aoDespublicarRemoto: (utilizador, tipoMedia) => {
          // Quem sai leva a sua janela com ele. Numa revanche com adversário novo, sem isto ficava o último fotograma do rival anterior colado por baixo do nome do rival novo.
          if (tipoMedia === "video") limparContentorDeRemoto(utilizador.uid);
        },
      });
    };

    entrarNoCampo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idBatalha, batalha?.idA, batalha?.idB, espectador, ligacao.tentativa]);

  // 2. ANTENA DO ESTÁDIO: Escuta a partida em direto e atualiza o ecrã de todos (ISOLADA PARA A LIGA PK!)
  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined") return;

    // 🚀 CIRCUITO FECHADO LIGA: Escuta unicamente a coleção exclusiva da Liga PK
    const unsub = ligacao.registarListener(onSnapshot(doc(db, "batalhasAtivas_liga", idBatalha), (snap) => {
      if (snap.exists()) {
        const data = snap.data();
        setBatalha(data);

        if (data.poteBolasJogo !== undefined) {
          setPoteBolasGeral(Number(data.poteBolasJogo || 0));
        }

        // (O presente chega pela mensagem de sistema do chat — videoGatilho — e
        //  entra na fila lá. Antes também disparava aqui, pelo documento da batalha,
        //  e o mesmo presente tocava duas vezes com duas bombas.)

        // 🚀 DISPARO AUTOMÁTICO BLINDADO: Arranca se ambos estiverem prontos, executado por qualquer um dos dois streamers!
        const faseTexto = String(data.fase || "ESPERA").toUpperCase().trim();
        const souUmDosJogadores = auth.currentUser?.uid === data.idA || auth.currentUser?.uid === data.idB;
        
        if ((faseTexto === "ESPERA" || !data.fase) && data.prontoA && data.prontoB && souUmDosJogadores) {
          // 🚀 CIRCUITO FECHADO LIGA: Altera o estado na coleção exclusiva da Liga PK
          updateDoc(doc(db, "batalhasAtivas_liga", idBatalha), { 
            fase: "1ª PARTE", 
            tempo: 300, 
            criadoEmCampeonato: Date.now() 
          });
        }
      }
    }));
    return () => unsub();
  }, [idBatalha, batalha?.tempo, batalha?.ultimoVideo, microLigado]);

    // 3. CONTAGEM DO PÚBLICO E CLIQUES (OLHINHO NÉON E TAP-TAPS ISOLADOS LIGA PK)
  useEffect(() => {
    if (!idBatalha || idBatalha === "undefined" || auth.currentUser?.uid == null) return;
    const meuUid = auth.currentUser.uid;
    let minhaBancadaFutebol = 'A';

    if (meuUid === batalha?.idA) {
      minhaBancadaFutebol = 'A';
    } else if (meuUid === batalha?.idB) {
      minhaBancadaFutebol = 'B';
    } else {
      const charCodeSoma = meuUid.split('').reduce((acc, char) => acc + char.charCodeAt(0), 0);
      minhaBancadaFutebol = charCodeSoma % 2 === 0 ? 'A' : 'B';
    }

    // 🚀 CIRCUITO FECHADO LIGA: Regista a presença na sala exclusiva da Liga PK
    const presencaRef = doc(db, "batalhasAtivas_liga", idBatalha, "presencas", meuUid);
    setDoc(presencaRef, { 
      uid: meuUid,
      nome: auth.currentUser?.displayName || "Craque", 
      foto: auth.currentUser?.photoURL || "/hero.png",
      bancada: minhaBancadaFutebol,
      entrada: Date.now() 
    }).catch(() => {});

    // 🚀 CIRCUITO FECHADO LIGA: Escuta o público na sala exclusiva da Liga PK
    const q = collection(db, "batalhasAtivas_liga", idBatalha, "presencas");
    const unsub = onSnapshot(q, (snap) => {
      setTotalGente(snap.size);
      const espectadoresMapeados = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setListaEspectadoresPK(espectadoresMapeados);
      setListaEspectadores(espectadoresMapeados);
    }, (err) => console.error("Erro no olhinho da liga:", err));

    return () => { 
      deleteDoc(presencaRef).catch(() => {}); 
      unsub();
    };
  }, [idBatalha, batalha?.idA, batalha?.idB]);

  // Garante a reposição e limpeza síncrona dos Taps ao iniciar jogo novo
  useEffect(() => {
    setTotalTapTapsArena(0);
    setTapsClaqueA(0);
    setTapsClaqueB(0);
  }, [idBatalha]);

  // Sincroniza os contadores de cliques (Tap-Taps) na tela vindos da sala exclusiva da Liga PK
  useEffect(() => {
    if (!idBatalha) return;
    const unsubTaps = onSnapshot(doc(db, "batalhasAtivas_liga", idBatalha), (docSnap) => {
      if (docSnap.exists()) {
        const data = docSnap.data();
        setTotalTapTapsArena(data.totalTapTaps || 0);
        setTapsClaqueA(Number(data.tapsClaqueA || data.claqueAtivosA || 0));
        setTapsClaqueB(Number(data.tapsClaqueB || data.claqueAtivosB || 0));
      }
    });
    return () => unsubTaps();
  }, [idBatalha]);

  // (O motor da fila de presentes vive em src/filaDePresentes.js.)
  
  // 4. JUIZ MESTRE DA LIGA (ENGINE DE FLUIDEZ MESTRE DE 1000MS ISOLADO LIGA PK)
  useEffect(() => {
    if (!batalha) return;
    if (batalha.tempo !== ultimoTiqueRef.current.tempo) {
      ultimoTiqueRef.current = { tempo: batalha.tempo, em: Date.now() };
      setRelogioParado(false);
    }
  }, [batalha?.tempo, batalha]);

  useEffect(() => {
    const emJogo = batalha?.fase && batalha.fase !== "ESPERA" && batalha.fase !== "FIM";
    if (!emJogo) { setRelogioParado(false); return; }

    const vigia = setInterval(() => {
      setRelogioParado(Date.now() - ultimoTiqueRef.current.em > 10000);
    }, 2000);
    return () => clearInterval(vigia);
  }, [batalha?.fase]);

  useEffect(() => {
    if (!batalha) return;
    const meuUid = auth.currentUser?.uid;
    
    // TRANCA DE CO-ÁRBITRO LIGA: O Jogador A apita. O B só assume se o relógio do A parar por 10s!
    const souOArbitro = meuUid === batalha.idA || (meuUid === batalha.idB && relogioParado);
    if (!souOArbitro) return;

    let t;
    if (batalha.fase !== "ESPERA" && batalha.fase !== "FIM") {
      t = setInterval(async () => {
        if (batalha.tempo <= 1) {
          let novaFase = "";
          let novoTempo = 0;

          // 1. FLUXO REGULAMENTAR DE TEMPO DA LIGA
          if (batalha.fase === "1ª PARTE") { 
            novaFase = "INTERVALO"; 
            novoTempo = 60; 
          }
          else if (batalha.fase === "INTERVALO") { 
            novaFase = "2ª PARTE"; 
            novoTempo = 300; 
          }
          else if (batalha.fase === "2ª PARTE") {
            novaFase = "FIM";
            novoTempo = 0;
          }

          // 2. SE O JOGO CHEGOU AO FIM, APLICA O VEREDITO REGULAMENTAR DA LIGA
          if (novaFase === "FIM") {
            const pontosFinaisP1 = batalha.pontosA || 0;
            const pontosFinaisP2 = batalha.pontosB || 0;
            
            // Dispara síncronamente o motor contabilístico oficial da tabela classificativa da Liga!
            await aplicarResultadoNoBanco(batalha.idA, batalha.idB, pontosFinaisP1, pontosFinaisP2, false, false);
          }

          // 🚀 CIRCUITO FECHADO LIGA: Atualiza a mudança de fase na sala exclusiva da Liga PK
          await updateDoc(doc(db, "batalhasAtivas_liga", idBatalha), { 
            fase: novaFase, 
            tempo: novoTempo,
            ultimoTiqueEm: serverTimestamp()
          });
        } else {
          // 🚀 CIRCUITO FECHADO LIGA: Subtração atómica na sala exclusiva da Liga PK
          await updateDoc(doc(db, "batalhasAtivas_liga", idBatalha), {
            tempo: increment(-1),
            ultimoTiqueEm: serverTimestamp()
          }).catch(e => console.log("Erro ao descontar tempo na Liga PK:", e));
        }
      }, 1000);
    }
    return () => clearInterval(t);
  }, [batalha?.fase, batalha?.tempo, idBatalha, relogioParado]);

    // 🚀 FUNÇÃO MESTRE DO MICROFONE: Muta o Agora SDK e alterna as cores síncronamente (Liga PK)
  const alternarMicrofoneBatalha = () => {
    setMicroLigado((ligado) => {
      const proximoEstado = !ligado;
      if (typeof ligacao?.sessao?.audio?.setMuted === 'function') {
        ligacao.sessao.audio.setMuted(!proximoEstado).catch((err) => console.error("Erro no mute:", err));
      }
      return proximoEstado;
    });
  };

  // SENSOR VISUAL: Projeta os Alertas do Árbitro na Tela em Tempo Real (Liga PK Style)
  useEffect(() => {
    if (!batalha?.fase) return;

    const faseTexto = String(batalha.fase).toUpperCase().trim();

    if (faseTexto === "1ª PARTE") {
      setMensagemJuiz("1ª PARTE - APITO INICIAL! ⚽");
    } else if (faseTexto === "INTERVALO") {
      setMensagemJuiz("INTERVALO! ⏳");
    } else if (faseTexto === "2ª PARTE") {
      setMensagemJuiz("2ª PARTE - INICIADA! ⚽");
    } else if (faseTexto === "FIM") {
      setMensagemJuiz("JOGO TERMINADO! REGISTANDO O VENDEDOR... 🏆");
      const timeoutFimNormal = setTimeout(() => {
        setMensagemJuiz(""); 
        setMostrarResultadoFinal(true);
        const timeoutResNormal = setTimeout(() => {
          setMostrarResultadoFinal(false);
          setMostrarOpcoesFim(true);
        }, 4000);
        return () => clearTimeout(timeoutResNormal);
      }, 3000);
      return () => clearTimeout(timeoutFimNormal);
    }
    
    if (faseTexto !== "FIM") {
      const timeout = setTimeout(() => setMensagemJuiz(""), 4000);
      return () => clearTimeout(timeout);
    }
  }, [batalha?.fase]);

      // 5. MOTOR CONTABILÍSTICO DA LIGA PK (MUDANÇA ATÓMICA DE FASE E ROTAÇÃO AUTOMÁTICA DE JORNADA)
  const aplicarResultadoNoBanco = async (idA, idB, pontosFinalA, pontosFinalB, porWO = false, woDuplo = false) => {
    try {
      const { doc: fDoc, updateDoc: fUpdateDoc, increment: fIncrement, collection: fColl, getDocs: fGetDocs } = await import('firebase/firestore');

      const chaveJornada = `jornada_${batalha?.jornada || 1}`;
      const moedasGanhasA = porWO ? pontosFinalA : (batalha?.pontosA || 0);
      const moedasGanhasB = porWO ? pontosFinalB : (batalha?.pontosB || 0);

      // 🚀 CIRCUITO FECHADO LIGA: Carimba o fim do jogo diretamente no objeto de jornadas do documento mestre
      const caminhoObjetoJogo = `jornadas.${chaveJornada}.${idJogoNaJornada}`;
      
      await fUpdateDoc(fDoc(db, "ligas_ativas", idLiga), {
        [`${caminhoObjetoJogo}.status`]: 'encerrado',
        [`${caminhoObjetoJogo}.finalizado`]: true,
        [`${caminhoObjetoJogo}.pontosP1`]: moedasGanhasA,
        [`${caminhoObjetoJogo}.pontosP2`]: moedasGanhasB
      }).catch(e => console.log("Erro ao carimbar fim do jogo no mapa da liga:", e));

      // Referências dos Perfis dos Jogadores na subcoleção de inscritos
      const p1Ref = fDoc(db, "ligas_ativas", idLiga, "inscritos", idA);
      const p2Ref = fDoc(db, "ligas_ativas", idLiga, "inscritos", idB);

      // B. SE FOR FALTA DE COMPARÊNCIA DUPLA (W.O. DUPLO)
      if (woDuplo) {
        await fUpdateDoc(p1Ref, { derrotas: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(0) });
        await fUpdateDoc(p2Ref, { derrotas: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(0) });
      } else {
        // C. DISTRIBUIÇÃO DINÂMICA DE PONTOS POR MOEDAS REAIS RECEBIDAS (DESEMPATE DIRETO)
        if (moedasGanhasA > moedasGanhasB) {
          await fUpdateDoc(p1Ref, { pontosTabela: fIncrement(3), vitorias: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(moedasGanhasA) });
          await fUpdateDoc(p2Ref, { derrotas: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(moedasGanhasB) });
        } else if (moedasGanhasB > moedasGanhasA) {
          await fUpdateDoc(p2Ref, { pontosTabela: fIncrement(3), vitorias: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(moedasGanhasB) });
          await fUpdateDoc(p1Ref, { derrotas: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(moedasGanhasA) });
        } else {
          await fUpdateDoc(p1Ref, { pontosTabela: fIncrement(1), empates: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(moedasGanhasA) });
          await fUpdateDoc(p2Ref, { pontosTabela: fIncrement(1), empates: fIncrement(1), totalMoedasGanhasCompeticao: fIncrement(moedasGanhasB) });
        }
      }

      // 🛡️ D. GATILHO DA ÚLTIMA JORNADA: Se for a rodada final (Jornada 9), liquida o pote geral!
      if (chaveJornada === "jornada_9") {
        const inscritosSnap = await fGetDocs(fColl(db, "ligas_ativas", idLiga, "inscritos"));
        const listaInscritosDados = inscritosSnap.docs.map(d => d.data());

        // Ordena síncronamente a tabela final com os mesmos critérios exatos do ecrã
        const tabelaOrdenadaFinal = [...listaInscritosDados].sort((a, b) => {
          if ((b.pontosTabela || 0) !== (a.pontosTabela || 0)) return (b.pontosTabela || 0) - (a.pontosTabela || 0);
          return (b.totalMoedasGanhasCompeticao || 0) - (a.totalMoedasGanhasCompeticao || 0);
        });

        // Puxa o saldo atualizado do pote acumulado da liga
        const { getDoc: fGetDoc } = await import('firebase/firestore');
        const ligaDadosSnap = await fGetDoc(fDoc(db, "ligas_ativas", idLiga));
        const totalPoteBolas = ligaDadosSnap.data()?.poteAcumuladoBolas || 0;

        if (totalPoteBolas > 0 && tabelaOrdenadaFinal.length >= 2) {
          const idCampeao = tabelaOrdenadaFinal[0].uid;
          const idViceCampeao = tabelaOrdenadaFinal[1].uid;

          const fatiasCampeao = Math.round(totalPoteBolas * 0.75);
          const fatiasVice = Math.round(totalPoteBolas * 0.25);

          await fUpdateDoc(fDoc(db, "utilizadores", idCampeao), { saldoBolas: fIncrement(fatiasCampeao) });
          await fUpdateDoc(fDoc(db, "utilizadores", idViceCampeao), { saldoBolas: fIncrement(fatiasVice) });

          await fUpdateDoc(fDoc(db, "ligas_ativas", idLiga), {
            estadoCampeonato: "encerrado",
            statusInscricao: "arquivado",
            poteAcumuladoBolas: 0,
            vencedorId: idCampeao,
            viceId: idViceCampeao,
            premioCampeaoBolas: fatiasCampeao,
            premioViceBolas: fatiasVice
          });
          console.log(`🏆 LIGA ENCERRADA AUTOMATICAMENTE!`);
        }
      }

          // 🚀 ENGINE AUTOMÁTICA DE AVANÇO (BACKGROUND): Analisa o mapa de objetos real e vira a jornada se os 5 jogos fecharem
      try {
        const { getDoc: fGetDoc } = await import('firebase/firestore');
        const idLigaSeguro = idLiga || batalha?.idLiga;
        
        if (idLigaSeguro) {
          const ligaDadosSnap = await fGetDoc(fDoc(db, "ligas_ativas", idLigaSeguro));
          const dadosLigaReal = ligaDadosSnap.data();
          
          if (dadosLigaReal?.jornadas) {
            const mapaJogosObjeto = dadosLigaReal.jornadas[chaveJornada] || {};
            const listaJogosJornada = Object.values(mapaJogosObjeto);
            
            // TRANCA RÍGIDA MESTRE: Só valida e avança se o calendário contiver fisicamente os 5 confrontos gerados da rodada
            if (listaJogosJornada.length === 5) {
              const contagemEncerrados = listaJogosJornada.filter(j => j.status === 'encerrado' || j.finalizado === true).length;
              
              if (contagemEncerrados === 5) {
                console.log("🏆 JORNADA COMPLETA! Todas as 5 arenas fechadas. A virar campeonato...");
                await fUpdateDoc(fDoc(db, "ligas_ativas", idLigaSeguro), {
                  jornadaAtual: fIncrement(1)
                });
              }
            }
          }
        }
      } catch (errAutoJornada) {
        console.error("Erro no motor autónomo de rotação de jornadas:", errAutoJornada);
      }

    } catch (errCalc) {
      console.error("Erro ao aplicar contabilidade da jornada na tabela:", errCalc);
    }
  };

    // 6. LEITURA DO CHAT EM TEMPO REAL (CIRCUITO ISOLADO UNIFICADO CHAMPIONS STYLE)
  useEffect(() => {
    if (!idBatalha) return;
    
    // 🚀 UNIFICAÇÃO DE ROTA: Escuta exatamente a coleção onde os presentes e as mensagens reais coexistem
    const q = query(collection(db, "batalhasAtivas_liga", idBatalha, "chatsArena"), orderBy("criadoEm", "asc"));
    const unsub = onSnapshot(q, (snap) => {
      setMensagensChat(snap.docs.map(d => ({ id: d.id, ...d.data() })));
      
      if (typeof scrollToBottom === 'function') {
        setTimeout(() => scrollToBottom(), 100);
      }

      // DETETOR ATÓMICO: Captura os presentes em tempo real e joga-os para a esteira do Chroma Key!
      snap.docChanges().forEach((change) => {
        if (change.type === "added") {
          const dadosMsg = change.doc.data();
          if (dadosMsg.videoGatilho) {
            filaPresentes.enfileirar(dadosMsg.videoGatilho);
          }
        }
      });
    });
    return () => unsub();
  }, [idBatalha]);

  const enviarMensagemLiga = async () => {
  if (textoMensagem.trim() === "" || !idBatalha) return;
  const msg = textoMensagem;
  setTextoMensagem("");

  try {
    // 🔥 INJEÇÃO DE DADOS DE NÍVEL DEFINITIVA - CAMPEONATO DA LIGA
    await addDoc(collection(db, "batalhasAtivas_liga", idBatalha, "chatsArena"), {
      texto: `${msg}`,
      nome: auth.currentUser?.displayName || "Adepto",
      foto: auth.currentUser?.photoURL || "/hero.png",
      fotoUrl: auth.currentUser?.photoURL || "/hero.png",
      criadoEm: serverTimestamp(),
      uid: auth.currentUser?.uid,
      // Se userDados existir, calcula o nível em tempo real. Caso contrário, envia 1 por defeito.
      nivelAdepto: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' && userDados ? calcularNivel(userDados.xpAdepto || 0) : 1,
      nivelJogador: typeof calcularNivel === 'function' && typeof userDados !== 'undefined' && userDados ? calcularNivel(userDados.xpJogador || 0) : 1
    });
  } catch (errChatEnvio) {
    console.error("Erro ao enviar mensagem na rota da Liga:", errChatEnvio);
  }
};

  // 🚀 TRANCA DE SEGURANÇA CHAMPIONS STYLE: Corta o frame imediatamente se o Firebase ainda estiver a carregar!
  if (!batalha) return (
    <div style={{ color: 'white', textAlign: 'center', marginTop: '50px' }}>
      Entrando no Estádio da Liga...
    </div>
  );

    // 🚀 CÁLCULOS SEGUROS: Executados apenas quando a batalha já existe 100% no Firebase!
  const meuUidLogado = auth.currentUser?.uid;
  const souOJogadorA = meuUidLogado && (batalha?.p1?.uid === meuUidLogado || batalha?.idA === meuUidLogado);
  const souOJogadorB = meuUidLogado && (batalha?.p2?.uid === meuUidLogado || batalha?.idB === meuUidLogado);
  const souUmDosStreamers = souOJogadorA || souOJogadorB;

  const mapaJogadores = construirMapaJogadores(batalha);
  const jogadorEsq = mapaJogadores.anfitriao;
  const jogadorDir = mapaJogadores.adversario;

  const ptsEsq = jogadorEsq.pontos || 0;
  const ptsDir = jogadorDir.pontos || 0;
  const total = ptsEsq + ptsDir;
  const percEsq = total === 0 ? 50 : (ptsEsq / total) * 100;
  // 🚀 RELÓGIO REATIVO CHAMPIONS STYLE: Lê o estado do Firebase em tempo real em cada frame!
  const tempoVisual = batalha && batalha.tempo !== undefined ? Math.max(0, Number(batalha.tempo)) : 300;
  const souEspetador = auth.currentUser && auth.currentUser.uid !== batalha?.idA && auth.currentUser.uid !== batalha?.idB;

  return (
    <div style={{ backgroundColor: '#000', height: '100vh', width: '100vw', color: 'white', position: 'fixed', top: 0, left: 0, zIndex: 99999, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>

      {/* PLACAR ELETRÓNICO (PONTUAÇÃO REAL DE MOEDAS DA JORNADA) */}
      <div style={{ display: 'flex', justifyContent: 'space-around', padding: '15px', alignItems: 'center', flexShrink: 0 }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: '950', fontSize: '22px', fontFamily: 'monospace', color: '#FFF' }}>
            {ptsEsq.toLocaleString()}
          </div>
          <div style={{ fontSize: '10px', color: '#aaa', fontWeight: 'bold', marginTop: '2px' }}>{jogadorEsq.nome ? jogadorEsq.nome.split(' ')[0] : "Jogador 1"}</div>
        </div>
        <div style={{ background: 'linear-gradient(90deg, #39FF14 0%, #22cc00 100%)', color: 'black', padding: '6px 18px', borderRadius: '20px', fontWeight: '950', fontSize: '14px', boxShadow: '0 0 10px #39FF14' }}>
          {formatarTempo(tempoVisual)}
        </div>
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontWeight: '950', fontSize: '22px', fontFamily: 'monospace', color: '#FFF' }}>
            {ptsDir.toLocaleString()}
          </div>
          <div style={{ fontSize: '10px', color: '#aaa', fontWeight: 'bold', marginTop: '2px' }}>{jogadorDir.nome ? jogadorDir.nome.split(' ')[0] : "Jogador 2"}</div>
        </div>
      </div>

      {/* BANNER DO POTE EM TEMPO REAL NO TOPO DO ESTÁDIO */}
      <div style={{ textAlign: 'center', margin: '5px 0 15px 0' }}>
        <div style={{ 
          display: 'inline-block', background: 'rgba(255, 215, 0, 0.1)', 
          padding: '5px 15px', borderRadius: '10px', border: '1px solid #FFD700' 
        }}>
          <span style={{ color: '#FFD700', fontSize: '11px', fontWeight: '900', textShadow: '0 0 5px #FFD700' }}>
            POTE DA ARENA: {Math.round(batalha?.poteBolasJogo || poteBolasGeral || 0).toLocaleString()} ⚽
          </span>
        </div>
      </div>

      {/* BARRA DE PONTUAÇÃO BICOLOR DINÂMICA */}
      <div style={{ width: '94%', height: '32px', backgroundColor: '#222', margin: '0 auto', borderRadius: '8px', overflow: 'hidden', display: 'flex', position: 'relative', border: '2px solid #333', flexShrink: 0 }}>
        <div style={{ width: `${percEsq}%`, backgroundColor: '#ff4444', transition: 'width 0.5s' }} />
        <div style={{ width: `${100 - percEsq}%`, backgroundColor: '#4444ff', transition: 'width 0.5s' }} />
        <div style={{ position: 'absolute', width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 15px', fontWeight: 'bold', fontSize: '13px', boxSizing: 'border-box', pointerEvents: 'none' }}>
          <span>{ptsEsq.toLocaleString()} Pts</span>
          <span>{ptsDir.toLocaleString()} Pts</span>
        </div>
      </div>

          {/* 🚀 PONTO 8: ESTRUTURA SUPREMA ULTRA-COMPACTA CHAMPIONS (UNIFICADA EM AMARELO) */}
      <div style={{ display: 'flex', flexDirection: 'column', width: '94%', margin: '4px auto 12px auto', backgroundColor: 'rgba(255,255,255,0.02)', border: '1px solid #222', borderRadius: '12px', padding: '6px 10px', boxSizing: 'border-box', gap: '4px', zIndex: 100 }}>
        
        {/* LINHA SUPERIOR: CLAQUE ESQ · 👁️ CONTADOR · CLAQUE DIR */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '6px', width: '100%' }}>
          
          {/* Botão Claque Esquerda */}
          <button
            onClick={() => {
              const meuUidLogado = auth.currentUser?.uid;
              if (meuUidLogado === idA || meuUidLogado === idB) {
                alert("Os streamers em campo não podem comprar bilhetes de claque! ⚽");
                return;
              }
              if (euPertencoAClaqueA) {
                alert("Já pertences a esta Claque Oficial! 📣");
                return;
              }
              comprarAbonoClaqueChampionsA();
            }}
            style={{ 
              flex: 1, background: 'rgba(0,0,0,0.6)', 
              border: euPertencoAClaqueA ? '1px solid #39FF14' : '1px solid #FFD700', 
              borderRadius: '12px', padding: '4px 6px', 
              color: euPertencoAClaqueA ? '#39FF14' : '#FFD700', 
              fontSize: '10px', fontWeight: '900', cursor: 'pointer', whiteSpace: 'nowrap',
              boxShadow: euPertencoAClaqueA ? '0 0 6px rgba(57, 255, 20, 0.25)' : 'none'
            }}
          >
            {euPertencoAClaqueA ? "📣 CLAQUE MEMBRO (300 ⚽)" : "📣 CLAQUE (300 ⚽)"}
          </button>

          {/* 👁️ O OLHINHO NÉON CENTRAL DA BARRA */}
          <div 
            onClick={() => {
              setMostrarEspectadoresPK(true);
              setMostrarListaEspectadores(true);
            }}  
            style={{ display: 'flex', alignItems: 'center', gap: '3px', background: 'rgba(255, 215, 0, 0.1)', padding: '3px 8px', borderRadius: '10px', flexShrink: 0, cursor: 'pointer' }}
            title="Ver Adeptos no Estádio"
          >
            <span style={{ fontSize: '12px' }}>👁️</span>
            <span style={{ color: '#FFD700', fontSize: '11px', fontWeight: '950', fontFamily: 'monospace' }}>{totalGente}</span>
          </div>

          {/* Botão Claque Direita */}
          <button
            onClick={() => {
              const meuUidLogado = auth.currentUser?.uid;
              if (meuUidLogado === idA || meuUidLogado === idB) {
                alert("Os streamers em campo não podem comprar bilhetes de claque! ⚽");
                return;
              }
              if (euPertencoAClaqueB) {
                alert("Já pertences a esta Claque Oficial! 📣");
                return;
              }
              comprarAbonoClaqueChampionsB();
            }}
            style={{ 
              flex: 1, background: 'rgba(0,0,0,0.6)', 
              border: euPertencoAClaqueB ? '1px solid #39FF14' : '1px solid #FFD700', 
              borderRadius: '12px', padding: '4px 6px', 
              color: euPertencoAClaqueB ? '#39FF14' : '#FFD700', 
              fontSize: '10px', fontWeight: '900', cursor: 'pointer', whiteSpace: 'nowrap',
              boxShadow: euPertencoAClaqueB ? '0 0 6px rgba(57, 255, 20, 0.25)' : 'none'
            }}
          >
            {euPertencoAClaqueB ? "📣 CLAQUE MEMBRO (300 ⚽)" : "📣 CLAQUE (300 ⚽)"}
          </button>

        </div>

        {/* LINHA INFERIOR: ATIVOS ESQ · 🔥 CONTADOR TAPS · ATIVOS DIR */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', padding: '0 2px' }}>
          
          {/* Ativos Esquerda */}
          <span style={{ color: '#FFD700', fontSize: '9px', fontWeight: 'bold', flex: 1, textAlign: 'left', opacity: 0.85 }}>
            👥 {batalha?.claqueAtivosA || 0} ativos
          </span>

          {/* O Foguinho com o total de taps da Arena */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '3px', background: 'rgba(255, 69, 0, 0.1)', padding: '2px 8px', borderRadius: '10px', flexShrink: 0 }}>
            <span style={{ fontSize: '11px' }}>🔥</span>
            <span style={{ color: '#FF4500', fontSize: '10px', fontWeight: '950', fontFamily: 'monospace' }}>{totalTapTapsArena || 0}</span>
          </div>

          {/* Ativos Direita */}
          <span style={{ color: '#FFD700', fontSize: '9px', fontWeight: 'bold', flex: 1, textAlign: 'right', opacity: 0.85 }}>
            {batalha?.claqueAtivosB || 0} ativos 👥
          </span>

        </div>

      </div>

            {/* JANELAS DE VÍDEO DA JORNADA (AFINAÇÃO COMPACTA 28VH CHAMPIONS STYLE) */}
      <div ref={linhaVideoRef} style={{ display: 'flex', height: alturaLinhaVideo, marginTop: '15px', gap: '6px', position: 'relative', width: '94%', margin: '15px auto 0 auto', flexShrink: 0 }}>

        {/* A ENTRAR / ERRO DE LIGAÇÃO — por cima das duas janelas de vídeo */}
        <EstadoLigacaoEstadio
          estado={ligacao.estado}
          mensagemErro={ligacao.mensagemErro}
          aoTentarDeNovo={ligacao.tentarDeNovo}
          aoSair={typeof aoSair === 'function' ? aoSair : undefined}
        />

                {/* 🚀 LIGA PK CHAMPIONS STYLE: Câmaras compactas travadas a 50% de largura e 28vh de altura com cantos 12px */}
        <div id="janela-local" className="janela-video" style={{ width: '50%', height: '28vh', minHeight: '28vh', backgroundColor: '#111', borderRadius: '12px', position: 'relative', overflow: 'hidden', zIndex: 50, backgroundImage: jogadorEsq.foto ? `url(${jogadorEsq.foto})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="ecra-camara" />
        </div>
        
        {/* 🚀 LIGA PK CHAMPIONS STYLE: Câmaras compactas travadas a 50% de largura e 28vh de altura com cantos 12px */}
        <div id="janela-rival" className="janela-video" style={{ width: '50%', height: '28vh', minHeight: '28vh', backgroundColor: '#111', borderRadius: '12px', position: 'relative', overflow: 'hidden', zIndex: 50, backgroundImage: jogadorEsq.foto ? `url(${jogadorEsq.foto})` : 'none', backgroundSize: 'cover', backgroundPosition: 'center' }}>
          <div className="ecra-camara" />
        </div>
      </div>

          {/* CHAT ESTILO TIKTOK LIVE: REPLICADO DA CHAMPIONS PK COM FOTOS REAIS E BARREIRA VISUAL */}
      <div
  id="chat-batalha"
  style={{
    flex: '1 1 0%',
    minHeight: '0px',
    maxHeight: '40vh', /* Bloqueia o crescimento do chat para nunca engolir os ecrãs das câmaras */
    width: '94%',
    margin: '0 auto',
    overflowY: 'auto',
    display: 'flex',
    flexDirection: 'column',
    gap: '6px',
    padding: '6px 4px',
    boxSizing: 'border-box',
    overscrollBehavior: 'contain',
    position: 'relative',
    zIndex: 10 /* Tranca o chat por baixo do zIndex 50 das janelas de vídeo */
  }}
>
        <div style={{ marginTop: 'auto' }} />
        {mensagensChat.map((msg) => {
          const esMembroClaque = idsClaqueA?.includes(msg.uid) || idsClaqueB?.includes(msg.uid) || msg.isClaque || msg.claque === true || msg.tipoAutor === 'claque' || msg.tipo === 'sistema';
          
          // Fallback seguro de imagem para o autor comum ou para o robô do sistema
          const fotoAutorChat = (msg.uid === "sistema_liga" || msg.uid === "sistema_champions" || msg.tipo === "sistema") 
            ? (msg.fotoUrl || msg.foto || "/hero.png") 
            : (msg.foto || msg.fotoUrl || "/hero.png");

          // Limpa a formatacao antiga do arroba caso venha agarrada ao texto
          const textoLimpo = String(msg.texto || "").replace(/^@?[\w\s]+:\s*/, "");
          const autorNome = msg.nome || (msg.texto ? msg.texto.split(':')[0]?.replace('@', '') : "Adepto");

          return (
            <div 
              key={msg.id} 
              style={{ 
                fontSize: '13px', 
                color: esMembroClaque ? '#FFD700' : '#fff', 
                background: 'rgba(0, 0, 0, 0.6)', 
                padding: '6px 12px', 
                borderRadius: '15px', 
                alignSelf: 'flex-start', 
                maxWidth: '90%', 
                border: esMembroClaque ? '1.5px solid #FFD700' : '1px solid rgba(57, 255, 20, 0.15)',
                boxShadow: esMembroClaque ? '0 0 12px rgba(255, 215, 0, 0.4)' : 'none',
                fontWeight: esMembroClaque ? 'bold' : 'normal',
                display: 'flex',
                alignItems: 'center',
                gap: '8px'
              }}
            >
              {/* INJEÇÃO DA FOTO REAL DO ADEPTO - SEM PISCAR PRETO */}
              <img 
                src={fotoAutorChat} 
                alt="" 
                style={{ width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover', border: esMembroClaque ? '1px solid #FFD700' : '1px solid #39FF14' }} 
                onError={(e) => { e.target.src = "/hero.png"; }}
              />
              
                      <div style={{ display: 'flex', flexDirection: 'column' }}>
          
          {/* 🌟 LINHA HORIZONTAL DOS CRACHÁS NÉON (INJETADA AQUI) */}
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px', marginBottom: '2px' }}>
            {/* Crachá de Adepto (Rosa) + Texto do Nível */}
            {msg.nivelAdepto && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <img 
                  src={obterImagemAdepto(msg.nivelAdepto)} 
                  alt={`Adepto Lv ${msg.nivelAdepto}`} 
                  style={{ width: '14px', height: '14px', borderRadius: '50%', border: '1px solid #FF007F' }} 
                />
                <span style={{ color: '#FF007F', fontSize: '9px', fontWeight: '900', textShadow: '0 0 4px #FF007F' }}>
                  Lv.{msg.nivelAdepto}
                </span>
              </div>
            )}

            {/* Crachá de Jogador (Verde) + Texto do Nível */}
            {msg.nivelJogador && (
              <div style={{ display: 'flex', alignItems: 'center', gap: '2px' }}>
                <img 
                  src={obterImagemJogador(msg.nivelJogador)} 
                  alt={`Jogador Lv ${msg.nivelJogador}`} 
                  style={{ width: '14px', height: '14px', borderRadius: '50%', border: '1px solid #39FF14' }} 
                />
                <span style={{ color: '#39FF14', fontSize: '9px', fontWeight: '900', textShadow: '0 0 4px #39FF14' }}>
                  Lv.{msg.nivelJogador}
                </span>
              </div>
            )}
          </div>

          <span style={{ fontSize: '10px', color: esMembroClaque ? '#FFD700' : '#fff' }}>
            {msg.nomeInfrator ? msg.nomeInfrator : autorNome}
          </span>

                <span style={{ marginTop: '1px' }}>{msg.nomeInfrator ? textoLimpo : (msg.texto?.includes(':') ? msg.texto.split(':').slice(1).join(':') : msg.texto)}</span>
              </div>
            </div>
          );
        })}
        <div ref={messagesEndRef} />
      </div>

          {/* PROJETOR ABSOLUTO DE LETREIROS DE APITOS NO CENTRO DO ESTÁDIO (FILTRADO ANTI-COLISÃO) */}
      {mensagemJuiz && batalha?.fase !== "FIM" && (
        <div style={{ position: 'absolute', width: '100%', top: '40%', transform: 'translateY(-50%)', textAlign: 'center', color: '#39FF14', fontSize: '26px', fontWeight: '900', textShadow: '0 0 10px black', zIndex: 50 }}>
          {mensagemJuiz}
        </div>
      )}

      {/* ETIQUETAS DE RESULTADO FINAL DO RELÓGIO DA LIGA */}
      {batalha?.fase === "FIM" && (
        <>
          {(batalha.pontosA || 0) === (batalha.pontosB || 0) ? (
            <div style={{ position: 'absolute', left: '50%', top: '40%', transform: 'translate(-50%, -50%)', color: '#ffcc00', fontSize: '40px', fontWeight: '900', textShadow: '0 0 20px black', zIndex: 9999, whiteSpace: 'nowrap' }}>
              EMPATE 🤝
            </div>
          ) : (
            <>
              <div style={{ position: 'absolute', left: '25%', top: '40%', transform: 'translate(-50%, -50%)', color: (batalha.pontosA || 0) > (batalha.pontosB || 0) ? "#39FF14" : "#ff4444", fontSize: '30px', fontWeight: '900', textShadow: '0 0 15px black', zIndex: 9999 }}>
                {(batalha.pontosA || 0) > (batalha.pontosB || 0) ? "VITÓRIA 🏆" : "DERROTA 🟥"}
              </div>
              <div style={{ position: 'absolute', left: '75%', top: '40%', transform: 'translate(-50%, -50%)', color: (batalha.pontosB || 0) > (batalha.pontosA || 0) ? "#39FF14" : "#ff4444", fontSize: '30px', fontWeight: '900', textShadow: '0 0 15px black', zIndex: 9999 }}>
                {(batalha.pontosB || 0) > (batalha.pontosA || 0) ? "VITÓRIA 🏆" : "DERROTA 🟥"}
              </div>
            </>
          )}
        </>
      )}

      {/* 🚀 OPÇÕES FINAIS: TRANCAGEM DO MAPA MESTRE DA LIGA E LIMPEZA DE SALA ISOLADA */}
      {batalha?.fase === "FIM" && (
        <div style={{ position: 'absolute', width: '100%', top: '50%', transform: 'translateY(-50%)', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '15px', zIndex: 60 }}>
          <button
            onClick={async () => {
              try {
                const { doc: fDoc, deleteDoc: fDeleteDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
                const idLigaReal = idLiga || batalha?.idLiga;
                
                // 1. CARIMBO OFICIAL: Atualiza o mapa de jogos diretamente no documento mestre da liga!
                if (idLigaReal && batalha?.jornada && idJogoNaJornada) {
                  const chaveJornada = `jornada_${batalha.jornada}`;
                  const campoParaAtualizar = `jornadas.${chaveJornada}.${idJogoNaJornada}`;
                  
                                    await fUpdateDoc(fDoc(db, "ligas_ativas", idLigaReal), {
                    [`${campoParaAtualizar}.status`]: 'encerrado',
                    [`${campoParaAtualizar}.finalizado`]: true,
                    [`${campoParaAtualizar}.pontosP1`]: batalha?.pontosA || 0,
                    [`${campoParaAtualizar}.pontosP2`]: batalha?.pontosB || 0
                  }).catch(e => console.log("Aviso de gravação na jornada:", e));
                }

      // 2. 🚀 CIRCUITO FECHADO LIGA: Limpa a presença local na sala exclusiva da Liga PK
                if (auth.currentUser?.uid) {
                  await fDeleteDoc(fDoc(db, "batalhasAtivas_liga", idBatalha, "presencas", auth.currentUser.uid)).catch(() => {});
                }
                
                if (typeof aoSair === 'function') aoSair();
              } catch (errSair) { 
                console.error("Erro crítico ao salvar fim de jogo:", errSair); 
                if (typeof aoSair === 'function') aoSair();
              }
            }}
            style={{ background: 'linear-gradient(135deg, #39FF14 0%, #00bc2f 100%)', color: 'black', border: 'none', borderRadius: '30px', padding: '15px 35px', fontSize: '15px', fontWeight: '950', cursor: 'pointer', boxShadow: '0 0 15px #39FF14', textTransform: 'uppercase', letterSpacing: '0.5px', zIndex: 99999 }}
          >
            SAIR DA ARENA & SALVAR 🏆
          </button>
        </div>
      )}

      {/* 🚀 ANTENA DE AUTO-SAIR PARA ADEPTOS: Remove o fã do estádio automaticamente 3 segundos após o fim natural */}
      {(() => {
        const meuEfeito = window.React?.useEffect || import('react').then(m => m.useEffect);
        if (typeof meuEfeito === 'function') {
          meuEfeito(() => {
            if (souEspetador && batalha?.fase === "FIM") {
              const timeoutAutoSair = setTimeout(() => {
                if (typeof aoSair === 'function') aoSair();
              }, 3000);
              return () => clearTimeout(timeoutAutoSair);
            }
          }, [batalha?.fase]);
        }
        return null;
      })()}

      {/* BOTÃO RETORNO DE SEGURANÇA PARA ESPETADORES DURANTE O JOGO (✕) */}
      {souEspetador && batalha?.fase !== "FIM" && (
        <button 
          onClick={() => { if (typeof aoSair === 'function') aoSair(); }}
          style={{ position: 'absolute', top: '10px', right: '10px', background: 'rgba(0,0,0,0.5)', color: 'white', border: 'none', width: '35px', height: '35px', borderRadius: '50%', fontWeight: 'bold', fontSize: '18px', zIndex: 100, cursor: 'pointer' }}
        >
          ✕
        </button>
      )}

      {/* MOTOR UNIFICADO DA LIGA: PRESENTES MP4 COM CHROMA KEY (SEM APAGÃO PRETO)
          Um presente com versão sem fundo é desenhado só pela segunda camada
          (mais abaixo) — antes as duas camadas tocavam o mesmo vídeo uma por cima da outra. */}
      {videoAtivo && !videoSemFundo(videoAtivo) && (
        <div style={{
          position: 'fixed',
          inset: 0,
          zIndex: 9999999,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'transparent',
          pointerEvents: 'none'
        }}>
          <div style={{ position: 'relative', width: '300px', height: '300px' }}>
            {/* Canvas que tritura e limpa o fundo VERDE em tempo real nos jogos da Liga */}
            <canvas
              ref={(canvas) => {
                if (!canvas) return;
                const video = document.getElementById('video_player_liga_premium');
                if (!video) return;
                const ctx = canvas.getContext('2d');
                let frameId;
                
                const limparVerde = () => {
                  if (video.paused || video.ended) return;
                  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                  const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                  const len = imgData.data.length;
                  
                  for (let i = 0; i < len; i += 4) {
                    const r = imgData.data[i];
                    const g = imgData.data[i+1];
                    const b = imgData.data[i+2];
                    
                    // Fórmula Chroma Key idêntica para o verde do Kling AI
                    if (g > 55 && g > r * 1.15 && g > b * 1.15) {
                      imgData.data[i+3] = 0;
                    }
                  }
                  ctx.putImageData(imgData, 0, 0);
                  frameId = requestAnimationFrame(limparVerde);
                };
                
                video.addEventListener('play', limparVerde);
                return () => cancelAnimationFrame(frameId);
              }}
              width={480}
              height={480}
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
            {/* O vídeo corre mudo em background apenas para alimentar o triturador do Canvas */}
            <video
              id="video_player_liga_premium"
              src={videoAtivo}
              autoPlay
              playsInline
              muted
              style={{ display: 'none' }}
            />
          </div>
        </div>
      )}

                  {/* 🚀 REMOVIDA A BARRA FIXA ANTIGA CONTRA DESALINHAMENTO DO CHAT */}

      {/* 🚀 RODAPÉ COMPLETO DA LIGA PK (VISUAL COMPACTO ESTILO CHAMPIONS INTEGRADO PARA ADEPTOS) */}
      <div style={{ display: 'flex', flexDirection: 'column', paddingBottom: 'calc(10px + env(safe-area-inset-bottom))', paddingLeft: '15px', paddingRight: '15px', paddingTop: '10px', background: '#000', borderTop: '1px solid #111', gap: '10px', flexShrink: 0 }}>
        
              {souEspetador ? (
          /* FEED DE CHAT DO ADEPO EM LINHA CONTÍNUA FLUIDA E COMPACTA */
          <div style={{ display: 'flex', gap: '6px', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
            <input 
              value={textoMensagem} 
              onChange={(e) => setTextoMensagem(e.target.value)} 
              onKeyDown={(e) => e.key === 'Enter' && enviarMensagemLiga()} 
              placeholder="Apoia o teu streamer na Liga..." 
              style={{ 
                flex: 1, 
                minWidth: 0, 
                padding: '10px 14px', 
                borderRadius: '25px', 
                border: '1px solid #333', 
                background: '#111', 
                color: 'white', 
                fontSize: '13px' 
              }} 
            />
            
            {/* O Botão da Bola de Futebol para Enviar a Mensagem */}
            <button 
              onClick={enviarMensagemLiga} 
              style={{ 
                background: '#39FF14', 
                border: 'none', 
                width: '36px', 
                height: '36px', 
                borderRadius: '50%', 
                fontSize: '18px', 
                cursor: 'pointer', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center', 
                flexShrink: 0 
              }}
            >
              ⚽
            </button>
            
            {/* O BOTÃO DO FOGO (TAP TAP) ALINHADO NA LINHA FLUIDA DO ADEPTO */}
            <button
              onClick={processarTapTapArena}
              style={{
                background: 'rgba(255, 0, 127, 0.1)',
                border: '1px solid #FF007F',
                width: '36px',
                height: '36px',
                borderRadius: '50%',
                fontSize: '18px',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 0 8px rgba(255, 0, 127, 0.3)',
                flexShrink: 0
              }}
            >
              🔥
            </button>

            {/* 🔗 BOTÃO PARTILHA: Colado na esteira e perfeitamente centrado ao lado do prémio */}
            <button
              onClick={async () => {
                const urlLigaJogo = window.location.href;
                if (navigator.share) {
                  try {
                    await navigator.share({
                      title: 'Vem assistir à Liga PK! ⚽🔥',
                      text: 'Entra no estádio agora para apoiar o teu craque favorito na rodada em direto!',
                      url: urlLigaJogo,
                    });
                  } catch (errShare) {
                    console.log("Partilha fechada:", errShare);
                  }
                } else {
                  try {
                    await navigator.clipboard.writeText(urlLigaJogo);
                    alert("Link do estádio copiado para a área de transferência! 📋⚽");
                  } catch (errClip) {
                    console.error("Erro ao copiar:", errClip);
                  }
                }
              }}
              style={{ background: '#111', color: '#39FF14', border: '1px solid #39FF14', borderRadius: '50%', width: '36px', height: '36px', fontSize: '16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 8px rgba(57, 255, 20, 0.2)', flexShrink: 0 }}
              title="Partilhar Estádio"
            >
              🔗
            </button>

            {/* 🎁 INTERCONEXÃO: O BOTÃO REDONDO DE PRESENTES FILTRADO RIGOROSAMENTE SÓ NOS 5 MINUTOS DE JOGO */}
            {batalha?.fase && ["1ª PARTE", "2ª PARTE"].includes(String(batalha.fase).toUpperCase().trim()) && (
              <button 
                onClick={() => setMostrarPresentesPK(true)}
                style={{ 
                  background: 'linear-gradient(135deg, #FF8C00 0%, #FF4500 100%)', 
                  border: 'none', 
                  width: '36px', 
                  height: '36px', 
                  borderRadius: '50%', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  cursor: 'pointer', 
                  boxShadow: '0 0 8px rgba(255, 69, 0, 0.4)', 
                  fontSize: '18px', 
                  flexShrink: 0 
                }}
                title="Enviar Presente"
              >
                🎁
              </button>
            )}
          </div>
        ) : (

          /* CONTROLOS DOS STREAMERS (PRESERVADO INTEIRAMENTE DO TEU TOSHIBA) */
          <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', width: '100%', alignItems: 'center' }}>
            
            {/* LINHA 1: INICIAR PK · X · 🔗 · 🎤 */}
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', width: '100%' }}>
              
              {/* 1. BOTÃO INICIAR PK (INTELIGÊNCIA SÍNCRONA DUPLA - INDEPENDENTE DA ORDEM DE CLIQUE) */}
              <button
                onClick={async () => {
                  const faseTexto = String(batalha?.fase || "ESPERA").toUpperCase().trim();
                  if (faseTexto === "ESPERA" && souUmDosStreamers) {
                    const { doc: fDoc, getDoc: fGetDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
                    const partidaRef = fDoc(db, "batalhasAtivas_liga", idBatalha);
                    
                    const snapPartida = await fGetDoc(partidaRef);
                    const dadosAtuais = snapPartida.exists() ? snapPartida.data() : {};

                    // Determina dinamicamente qual a propriedade que ESTE utilizador vai ativar
                    const campoProntoMeu = souOJogadorA ? "prontoA" : "prontoB";
                    const campoProntoRival = souOJogadorA ? "prontoB" : "prontoA";

                    const rivalJaEstaPronto = dadosAtuais[campoProntoRival] === true;

                    if (rivalJaEstaPronto) {
                      // Se o rival já clicou antes, o meu clique dispara o estádio síncronamente!
                      await fUpdateDoc(partidaRef, {
                        [campoProntoMeu]: true,
                        fase: "1ª PARTE",
                        tempo: 300,
                        criadoEmCampeonato: Date.now()
                      });
                    } else {
                      // Se sou o primeiro a clicar, deixa o meu carimbo registado e aguarda o rival
                      await fUpdateDoc(partidaRef, { [campoProntoMeu]: true });
                    }
                  }
                }}
                style={{
                  background: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? '#222' : (((souOJogadorA ? batalha?.prontoA === true : batalha?.prontoB === true)) ? 'rgba(57, 255, 20, 0.2)' : '#39FF14'),
                  color: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? '#666' : 'black',
                  border: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? '1px solid #444' : 'none',
                  borderRadius: '25px', padding: '0 25px', height: '42px',
                  fontWeight: '950', fontSize: '13px', cursor: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? 'default' : 'pointer', 
                  letterSpacing: '0.5px', boxShadow: (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") ? 'none' : '0 0 10px #39FF14',
                  whiteSpace: 'nowrap', textTransform: 'uppercase'
                }}
              >
                { (batalha?.fase && batalha?.fase !== "ESPERA" && batalha?.fase !== "FIM") 
                  ? "EM JOGO ⚔️" 
                  : (((souOJogadorA ? batalha?.prontoA : batalha?.prontoB)) ? "AGUARDANDO..." : "INICIAR PK") 
                }
              </button>

              {/* Botão Recusar / Cancelar (✕) */}
              <button 
                onClick={() => { if (typeof aoSair === 'function') aoSair(); }}
                style={{ background: 'rgba(255, 49, 49, 0.15)', color: '#FF3131', border: '1px solid #FF3131', borderRadius: '50%', width: '42px', height: '42px', fontSize: '18px', fontWeight: '900', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 10px rgba(255, 49, 49, 0.3)' }}
              >
                ✕
              </button>
  
                        {/* 🔗 BOTÃO PARTILHA PREMIUM: Abre as redes nativas do telemóvel igualzinho à Champions! */}
            <button
              onClick={async () => {
                const urlLigaJogo = window.location.href;
                if (navigator.share) {
                  try {
                    await navigator.share({
                      title: 'Vem assistir à Liga PK! ⚽🔥',
                      text: 'Entra no estádio agora para apoiar o teu craque favorito na rodada em direto!',
                      url: urlLigaJogo,
                    });
                  } catch (errShare) {
                    console.log("Partilha fechada:", errShare);
                  }
                } else {
                  try {
                    await navigator.clipboard.writeText(urlLigaJogo);
                    alert("Link do estádio copiado para a área de transferência! 📋⚽");
                  } catch (errClip) {
                    console.error("Erro ao copiar:", errClip);
                  }
                }
              }}
              style={{ background: '#111', color: '#39FF14', border: '1px solid #39FF14', borderRadius: '50%', width: '42px', height: '42px', fontSize: '18px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 10px rgba(57, 255, 20, 0.3)' }}
              title="Partilhar Estádio"
            >
              🔗
            </button>

            {/* 🎤 BOTÃO MICROFONE DINÂMICO PREMIUM: Estado bicolor funcional e livre de bloqueios */}
            <button
              onClick={alternarMicrofoneBatalha}
              style={{ 
                background: microLigado ? '#39FF14' : '#222', 
                border: microLigado ? 'none' : '1px solid #ff4444', 
                color: microLigado ? 'black' : 'white', 
                width: '42px', height: '42px', borderRadius: '50%', fontSize: '18px', cursor: 'pointer', 
                display: 'flex', alignItems: 'center', justifyContent: 'center', 
                boxShadow: microLigado ? '0 0 10px #39FF14' : 'none' 
              }}
              title={microLigado ? "Mutar Microfone" : "Ligar Microfone"}
            >
              {microLigado ? "🎙️" : "🔇"}
            </button>

          </div>

          {/* LINHA 2: BASTÃO LONGO DE FECHAR ARENA SUPREMO */}
          <button 
            onClick={async () => {
              if (window.confirm("Aviso: Desejas encerrar definitivamente esta Arena da Liga? ⚽")) {
                const { doc: fDoc, updateDoc: fUpdateDoc } = await import('firebase/firestore');
                await fUpdateDoc(fDoc(db, "utilizadores", auth.currentUser.uid), { emLive: false }).catch(() => {});
                if (typeof aoSair === 'function') aoSair();
              }
            }}
            style={{ width: '100%', background: 'transparent', border: '2px solid #ff4444', color: '#ff4444', borderRadius: '25px', padding: '12px', fontSize: '12px', fontWeight: '950', textTransform: 'uppercase', letterSpacing: '1px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px', boxShadow: '0 0 10px rgba(255, 68, 68, 0.15)' }}
          >
            <span style={{ fontSize: '10px' }}>🟥</span> FECHAR ARENA
          </button>

        </div>
      )}
    </div>

          {/* 🔗 BOTÃO DE PARTILHA PREMIUM FLUTUANTE DISCRETO SÓ PARA O PÚBLICO */}
      {souEspetador && (
        <div style={{ position: 'absolute', bottom: '85px', right: '15px', zIndex: 1005 }}>
          <button
            onClick={async () => {
              const urlLigaJogo = window.location.href;
              if (navigator.share) {
                try {
                  await navigator.share({
                    title: 'Vem assistir à Liga PK! ⚽🔥',
                    text: 'Entra no estádio agora para apoiar o teu craque favorito na rodada em direto!',
                    url: urlLigaJogo,
                  });
                } catch (errShare) {
                  console.log("Partilha fechada:", errShare);
                }
              } else {
                try {
                  await navigator.clipboard.writeText(urlLigaJogo);
                  alert("Link do estádio copiado para a área de transferência! 📋⚽");
                } catch (errClip) {
                  console.error("Erro ao copiar:", errClip);
                }
              }
            }}
            style={{ background: '#111', color: '#39FF14', border: '1px solid #39FF14', borderRadius: '50%', width: '38px', height: '38px', fontSize: '16px', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', boxShadow: '0 0 8px rgba(57, 255, 20, 0.2)' }}
            title="Partilhar Estádio"
          >
            🔗
          </button>
        </div>
      )}

            {/* MOTOR UNIFICADO DA LIGA: PRESENTES MP4 COM CHROMA KEY (SEM APAGÃO PRETO) */}
      {videoAtivo && (
        <div style={{ position: 'fixed', inset: 0, zIndex: 9999999, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', backgroundColor: 'transparent', pointerEvents: 'none' }}>
          {/* 💍 Presente com versão sem fundo (assets/presentes/transparentes).
              O som da bomba já sai de quem dispara o presente; o vídeo vai sem som. */}
          {videoSemFundo(videoAtivo) ? (
            <PresenteTransparente
              key={chaveVideoAtivo}
              src={videoSemFundo(videoAtivo)}
              comSom={false}
              aoTerminar={() => filaPresentes.terminar(chaveVideoAtivo)}
            />
          ) : (
          <div style={{ position: 'relative', width: '300px', height: '300px' }}>
            <canvas
              ref={(canvas) => {
                if (!canvas) return;
                const video = document.getElementById('video_player_liga_premium');
                if (!video) return;
                const ctx = canvas.getContext('2d');
                let frameId;
                const limparVerde = () => {
                  if (video.paused || video.ended) return;
                  ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
                  const imgData = ctx.getImageData(0, 0, canvas.width, canvas.height);
                  const len = imgData.data.length;
                  for (let i = 0; i < len; i += 4) {
                    const r = imgData.data[i]; const g = imgData.data[i+1]; const b = imgData.data[i+2];
                    if (g > 55 && g > r * 1.15 && g > b * 1.15) { imgData.data[i+3] = 0; }
                  }
                  ctx.putImageData(imgData, 0, 0);
                  frameId = requestAnimationFrame(limparVerde);
                };
                video.addEventListener('play', limparVerde);
                return () => cancelAnimationFrame(frameId);
              }}
              width={480} height={480} style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
            <video
              id="video_player_liga_premium" src={videoAtivo} autoPlay playsInline muted
              onEnded={() => filaPresentes.terminar(chaveVideoAtivo)}
              // Um vídeo que falha nunca dispara o "ended": sem isto a fila parava.
              onError={() => filaPresentes.terminar(chaveVideoAtivo)}
              style={{ display: 'none' }}
            />
          </div>
          )}
        </div>
      )}

              {/* MODAL TRANSLÚCIDO COM A LISTA DE ESPECTADORES (ISOLADO PARA A LIGA PK) */}
      {(mostrarListaEspectadores || mostrarEspectadoresPK) && (
        <div style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0, 0, 0, 0.85)', backdropFilter: 'blur(8px)', zIndex: 999999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px' }}>
          <div style={{ background: '#0d0d0d', border: '2px solid #39FF14', boxShadow: '0 0 20px rgba(57, 255, 20, 0.3)', borderRadius: '16px', width: '100%', maxWidth: '360px', maxHeight: '70vh', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
            
            {/* Cabeçalho do Pop-up */}
            <div style={{ padding: '16px', borderBottom: '1px solid #262626', display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%', boxSizing: 'border-box' }}>
              <span style={{ color: '#fff', fontWeight: 'bold', fontSize: '16px' }}>
                👥 Adeptos no Estádio ({(listaEspectadoresPK || []).length})
              </span>
              <button 
                onClick={() => {
                  setMostrarListaEspectadores(false);
                  setMostrarEspectadoresPK(false);
                }}
                style={{ background: 'none', border: 'none', color: '#ff4d4d', fontSize: '18px', fontWeight: 'bold', cursor: 'pointer' }}
              >
                ✕
              </button>
            </div>
            
            {/* LISTA DE ADEPTOS COM SCROLL E AÇÕES */}
            <div style={{ padding: '16px', overflowY: 'auto', flex: 1 }}>
              {(!listaEspectadoresPK || listaEspectadoresPK.length === 0) ? (
                <p style={{ color: '#8c8c8c', textAlign: 'center', fontSize: '14px', margin: '20px 0' }}>
                  Ainda não há adeptos nas bancadas...
                </p>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {listaEspectadoresPK.map((adepto) => (
                    <div key={adepto.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '12px', background: '#141414', padding: '10px', borderRadius: '8px', border: '1px solid #262626' }}>
                      
                      <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <img src={adepto.foto || "/hero.png"} alt={adepto.nome} style={{ width: '40px', height: '40px', borderRadius: '50%', objectFit: 'cover', border: '2px solid #39FF14', flexShrink: 0 }} onError={(e) => { e.target.src = "/hero.png"; }} />
                        <span style={{ color: '#fff', fontSize: '14px', fontWeight: '500' }}>{adepto.nome || "Fã Incógnito"}</span>
                      </div>

                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                        {adepto.uid !== auth.currentUser?.uid && (
                          window.seguidosLocais?.includes(adepto.uid) ? (
                            <span style={{ color: '#39FF14', fontSize: '11px', fontWeight: 'bold', padding: '6px 12px' }}>✅ SEGUIDO</span>
                          ) : (
                            <button
                              onClick={async (e) => {
                                e.stopPropagation();
                                try {
                                  const { doc: fDoc, setDoc: fSetDoc, serverTimestamp: fTime } = await import('firebase/firestore');
                                  await fSetDoc(fDoc(db, "utilizadores", auth.currentUser.uid, "seguindo", adepto.uid), { nome: adepto.nome, data: fTime() });
                                  await fSetDoc(fDoc(db, "utilizadores", adepto.uid, "seguidores", auth.currentUser.uid), { nome: auth.currentUser.displayName || "Craque", data: fTime() });
                                  if (!window.seguidosLocais) window.seguidosLocais = [];
                                  window.seguidosLocais.push(adepto.uid);
                                  setTotalGente(prev => prev);
                                } catch (errSeg) { console.error(errSeg); }
                              }}
                              style={{ backgroundColor: 'rgba(255, 0, 127, 0.1)', color: '#FF007F', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer' }}
                            >
                              + SEGUIR
                            </button>
                          )
                        )}

                        {(() => {
                          const euSouOStreamerA = auth.currentUser?.uid === batalha?.idA;
                          const euSouOStreamerB = auth.currentUser?.uid === batalha?.idB;
                          const userEhJogador = adepto.uid === batalha?.idA || adepto.uid === batalha?.idB;
                          const souEuProprio = adepto.uid === auth.currentUser?.uid;
                          const podeExpulsar = !userEhJogador && ((euSouOStreamerA && adepto.bancada === 'A') || (euSouOStreamerB && adepto.bancada === 'B'));

                          if (podeExpulsar && !souEuProprio) {
                            return (
                              <button
                                onClick={async (e) => {
                                  e.stopPropagation();
                                  if (window.confirm(`Queres mesmo expulsar @${adepto.nome}? 🟥`)) {
                                    try {
                                      const { doc: fDoc, setDoc: fSetDoc, deleteDoc: fDeleteDoc } = await import('firebase/firestore');
                                      // 🚀 CIRCUITO FECHADO LIGA: Expulsa unicamente na sala exclusiva da Liga PK
                                      await fSetDoc(fDoc(db, "batalhasAtivas_liga", idBatalha, "expulsos", adepto.uid), { uid: adepto.uid, nome: adepto.nome, expulsoPor: auth.currentUser.uid, data: Date.now() });
                                      await fDeleteDoc(fDoc(db, "batalhasAtivas_liga", idBatalha, "presencas", adepto.uid));
                                      alert(`Utilizador expulso com sucesso!`);
                                    } catch (errKick) { console.error(errKick); }
                                  }
                                }}
                                style={{ backgroundColor: '#ff4444', color: 'black', border: 'none', padding: '6px 12px', borderRadius: '20px', fontSize: '11px', fontWeight: 'bold', cursor: 'pointer', marginLeft: '6px' }}
                              >
                                EXPULSAR 🟥
                              </button>
                            );
                          }
                          return null;
                        })()}
                      </div>

                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

          {/* 🚀 GAVETA SUPREMA DE PRESENTES LIGA PK (ESTILO REPLICADO DA CHAMPIONS COM FLUXO AUTÓNOMO DE 65%) */}
      {mostrarPresentesPK && (
        <div style={{ position: 'fixed', bottom: 0, left: 0, right: 0, backgroundColor: '#111', borderTop: '2px solid #39FF14', borderTopLeftRadius: '25px', borderTopRightRadius: '25px', padding: '15px 20px 25px 20px', zIndex: 3000, boxShadow: '0 -10px 30px rgba(0,0,0,0.9)', boxSizing: 'border-box', animation: 'slideUp 0.25s ease-out' }}>
          
          {/* Cabeçalho da Gaveta */}
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '15px' }}>
            <span style={{ color: '#39FF14', fontSize: '14px', fontWeight: '950', letterSpacing: '0.5px', textTransform: 'uppercase' }}>ESCOLHE O PRÉMIO ⚽</span>
            <button 
              onClick={() => setMostrarPresentesPK(false)}
              style={{ background: 'none', border: 'none', color: '#aaa', fontSize: '13px', fontWeight: 'bold', cursor: 'pointer' }}
            >
              Fechar ✕
            </button>
          </div>

          {/* DOIS BOTÕES GIGANTES NO TOPO: SELEÇÃO DO CRAQUE DE DESTINO */}
          <div style={{ display: 'flex', gap: '12px', marginBottom: '15px', width: '100%' }}>
            
            {/* Streamer Esquerda (Vermelho) */}
            <button
              onClick={() => setStreamerSelecionadoPresente('A')}
              style={{
                flex: 1, height: '44px', borderRadius: '12px', fontSize: '13px', fontWeight: '900', cursor: 'pointer',
                background: '#1a1a1a', color: '#ff4444',
                border: streamerSelecionadoPresente === 'A' ? '2px solid #ff4444' : '1px solid #333',
                boxShadow: streamerSelecionadoPresente === 'A' ? '0 0 10px rgba(255, 68, 68, 0.2)' : 'none',
                textTransform: 'uppercase', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '0 8px'
              }}
            >
              🟥 {batalha?.nomeA || "ANFITRIÃO"}
            </button>

            {/* Streamer Direita (Azul) */}
            <button
              onClick={() => setStreamerSelecionadoPresente('B')}
              style={{
                flex: 1, height: '44px', borderRadius: '12px', fontSize: '13px', fontWeight: '900', cursor: 'pointer',
                background: '#1a1a1a', color: '#4444ff',
                border: streamerSelecionadoPresente === 'B' ? '2px solid #4444ff' : '1px solid #333',
                boxShadow: streamerSelecionadoPresente === 'B' ? '0 0 10px rgba(68, 68, 255, 0.2)' : 'none',
                textTransform: 'uppercase', textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap', padding: '0 8px'
              }}
            >
              🟦 {batalha?.nomeB || "ADVERSÁRIO"}
            </button>

          </div>

          {/* GRELHA RÍGIDA DE PRESENTES COMPACTA V VERTICAL */}
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: '10px', maxHeight: '230px', overflowY: 'auto', overflowX: 'hidden', padding: '4px 2px', boxSizing: 'border-box', WebkitOverflowScrolling: 'touch' }}>
            {typeof LISTA_PRESENTES !== 'undefined' && LISTA_PRESENTES.map((pres) => (
              <div 
                key={pres.id}
                onClick={async () => {
                  setMostrarPresentesPK(false); // 🔥 FECHO IMEDIATO DA TELA
                  const idDestinatario = streamerSelecionadoPresente === 'A' ? batalha?.idA : batalha?.idB;
                  if (idDestinatario) {
                    // Dispara a tua função oficial intacta da Liga com a regra mestre dos 65%!
                    await enviarPresenteLiga(pres, idDestinatario);
                  }
                }}
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1a1a1a', padding: '6px 4px', borderRadius: '10px', border: '1px solid #252525', cursor: 'pointer', boxSizing: 'border-box', width: '100%', minWidth: 0 }}
              >
                <img src={pres.icone} style={{ width: '32px', height: '32px', marginBottom: '2px', objectFit: 'contain' }} alt="" />
                <span style={{ fontSize: '9px', color: '#fff', fontWeight: 'bold', textAlign: 'center', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{pres.nome}</span>
                <span style={{ fontSize: '8px', color: '#FFD700', marginTop: '1px', fontWeight: 'black', display: 'flex', alignItems: 'center', gap: '2px', justifyContent: 'center' }}>⚽ {pres.preco}</span>
              </div>
            ))}
          </div>

        </div>
      )}

    </div>
  );
}

export default JogosLigaPK;

